/* eslint-disable prettier */
/**
 * ES MX file
 */

import {
	roles,
	daySelection,
	GARoleTypeId,
	toggleCCPEntityDetail,
	readinessReportCategories,
	archiveReportQualifiedTypeId,
	natureOfEngagements,
	dashboardTabId,
	dashboardViews as dashboardViewsConstants,
	accountDesignations,
	groupRiskStatus,
	riskTypeIds
} from '../util/uiconstants';

export const labels = {
	clearFilter: "Borrar todo",
	canvasOversight: "Supervisión de Canvas",
	oversight: "supervisión",
	canvasLabel: "Canvas",
	myProjects: "Mis proyectos",
	otherProjects: "Otros proyectos",
	priorProjects: "Proyectos anteriores",
	completedProjects: "Proyectos finalizados",
	completedLabel: "Completado",
	createProject: "Crear proyecto",
	rollForward: "Puesta al día",
	rollForwardLabel: "Roll Forward",
	rollForwardTitle: "Rollfoward de su proyecto",
	project: "proyecto",
	openProject: "Proyecto abierto",
	manageUsers: "Administrar usuarios",
	rollForwardInstructionalText: "¿Estás seguro de que quieres hacer roll forward de tu proyecto? <br> Esto le permitirá utilizar su proyecto completado como plantilla al crear un nuevo proyecto. Se incorporará la siguiente información: nombre del proyecto, organigrama, grupos y administradores de grupos.",
	isClientUserError: "No tienes ningún proyecto activo. Hable con un miembro del equipo de EY para ser invitado a un proyecto.",
	activeProjects: "Proyectos activos",
	myActiveProjects: "Mis proyectos activos",
	otherActiveProjects: "Otros proyectos activos",
	myCompletedProjects: "Mis proyectos finalizados",
	myActiveProjectsPlaceholder: "Tiene acceso a los proyectos de supervision de  EY Canvas que se enumeran aquí. Seleccione un nombre de proyecto para abrirlo o haga clic en una cuenta para ver los detalles.",
	deleteProject: "Eliminar proyecto",
	deleteProjectModalText: "¿Está seguro de que desea eliminar este proyecto? <br>El proyecto se eliminará de su página de destino y ya no será accesible para ningún miembro del equipo.",
	createButton: "Crear proyecto",
	search: "buscar",
	searchEngagement: "Buscar compromiso",
	searchEngagements: "Buscar compromiso",
	searchEntitiesAndEngagements: "Buscar entidades y compromisos",
	searchClientList: "Buscar el nombre del cliente",
	noDataFound: "No hay datos que mostrar.",
	expand: "expandir",
	collapse: "Contraer",
	more: "más",
	options: "Opciones",
	editProject: "Editar proyecto",
	manageTeam: "Gestionar el equipo",
	markAsCompleted: "Marcar como completado",
	connectedTo: "Conectado a",
	connectedClients: "Clientes asociados",
	connectedToClients: (count) => `${count} ${count == 1 ? 'cliente' : 'clientes'}`,
	connectedToEngagements: (count) => `Compromisos: ${count == 0 ? 'Ninguno' : count}`,
	countEngagements: (count) => `${count} ${count === 1 ? 'compromiso' : 'compromisos'}`,
	connectToEngagements: (count) => `conectar ${count} ${count == 1 ? 'compromiso' : 'compromisos'}`,
	connectedToAccessGroups: (count) => `Conectado a ${count} ${count == 1 ? 'grupo' : 'grupos'}`,
	connectToAccessGroups: (count) => `conectar ${count} ${count == 1 ? 'grupo' : 'grupos'}`,
	entitiesLabelForCount: (count) => `${count} ${count == 1 ? 'Entidad' : 'Entidades'}`,
	viewsLabelForCount: (count) => `${count} ${count == 1 ? 'Vista' : 'Vistas'}`,
	domainsLabelForCount: (count) => `${count} ${count == 1 ? 'Dominio' : 'Dominio'}`,
	viewsLabelWithoutCount: (count) => `${count == 1 ? 'Vista' : 'Vistas'}`,
	domainsLabelWithoutCount: (count) => `${count == 1 ? 'Dominio' : 'Dominio'}`,
	engagement: "Compromiso",
	engagementNameLabel: "Nombre de la engagement",
	engagementPartnerLabel: "Socio del compromiso",
	partnerLabel: "socio",
	notInvited: "No invitado",
	clientNameLabel: "Nombre del cliente",
	client: "Clientes",
	codeLabel: "Código",
	idLabel: "identificación",
	engagements: "Engagement",
	engagementsLabel: "Compromisos",
	noResultsFound: "No se encontraron resultados.",
	submit: "Enviar",
	saveAndContinue: "Guardar y continuar",
	savecontinue: "Guardar y continuar",
	saveDraft: "Guardar como borrador",
	closeLabel: "cerrar",
	step1: "Paso 1",
	step2: "Paso 2",
	step3: "Paso 3",
	step4: "Paso 4",
	step5: "Paso 5",
	adminsNoneLabel: "Ninguno",
	domainsAllLabel: "Todo",
	adminsHeaderLabel: "Administradores:",
	domainsHeaderLabel: "Dominios:",
	moreCountLabel: '+ {0}',
	selectClient: "Seleccionar un cliente",
	createOrgChart: "Crear organigrama",
	connnectToCanvas: "Conéctese a  EY Canvas",
	viewSummary: "Ver resumen",
	viewLabel: "Ver",
	cancelLabel: "Cancelar",
	required: "necesario",
	filter: "filtro",
	filtersWarningMessage: "Se excedió el límite del filtro. Solo se pueden aplicar 25 filtros al mismo tiempo.",
	back: "Regresa",
	save: "Salvar",
	saveClose: "guardar & cerrar",
	continue: "Continuar",
	finish: "Finalizar",
	saveChanges: "Guardar cambios",
	projectName: "Nombre del proyecto",
	projectOwners: "Propietarios de proyectos",
	addAnotherProjectOwner: "Agregar otro propietario del proyecto",
	duplicateOwnerAdded: "Usuario duplicado",
	step1InstructionHeader: "Ingrese un nombre para su proyecto, agregue propietarios de proyectos adicionales y seleccione uno o más clientes de la lista a continuación para comenzar.",
	step1SubInstructionPart1: `Debe tener acceso a los códigos GIS, GFIS o Mercury del cliente o a un compromiso de EY Canvas para ver el nombre del cliente a continuación. Los clientes que seleccione en este paso determinarán qué compromisos de EY Canvas están disponibles para conectarse a su proyecto. Para obtener más información sobre cómo usar EY Canvas Oversight, consulte nuestro {enlace}`,
	step2InstructionHeader: "Cree un organigrama para el proyecto.",
	step2SubInstructionPart1: "El organigrama debe reflejar cómo su cliente administra su negocio. Se utilizará para resumir los datos de los engagement de EY Canvas que conecte a su proyecto y para administrar el acceso de los miembros internos y externos del equipo.",
	here: "aquí",
	zoomIn: "Acercar",
	zoomOut: "Alejar",
	expandAll: "Expandir todo",
	collapseAll: "Contraer todo",
	addLabel: "Agregar",
	editLabel: "Editar",
	removeLabel: "Eliminar",
	noRowsTemplateStringPart1: "No tienes acceso a ningún cliente. clic",
	noRowsTemplateStringPart2: "para obtener más información sobre cómo obtener acceso.",
	noRowSelected: "Seleccione al menos un cliente para continuar.",
	firstName: "Nombre",
	lastName: "apellido",
	displayLanguage: "Idioma de visualización",
	numberFormat: "Formato de número",
	dateFormat: "Formato de fecha",
	timezone: "Zona Horaria",
	theme: "Tema",
	chooseDisplayTheme: "Elija su tema de visualización predeterminado.",
	light: "Claro",
	dark: "Oscuro",
	usersettings: "Configuración del usuario",
	userOptions: "Opciones de usuario",
	clearHoverText: "Completado",
	noFiltersAvailable: "Ningún filtro disponible",
	dashboard: "Tablero",
	milestones: "Milestone",
	activityFeed: "Fuente de actividades",
	keyEvents: "Eventos clave",
	keyEventCompletion: "Finalización de eventos clave",
	canvasClientPortal: "Portal de clientes de Canvas",
	canvasClientPortalEy: "Portal de cliente de EY Canvas",
	groupAudit: "Auditoría de grupo",
	projectManagement: "gestión de proyectos",
	reporting: "Informes",
	insights: "Ideas",
	groupRiskAssessment: "Evaluación de riesgos grupales",
	internal: "interno",
	external: "Externo",
	members: "Miembros",
	show: "mostrar",
	showDetails: "Mostrar detalles",
	showMore: "Mostrar más",
	showLess: "Mostrar menos",
	clientName: "Nombre del cliente",
	clientsLabel: "Clientes",
	clientLabel: "Cliente",
	source: "fuente",
	code: "Código",
	accessDelegatedBy: "Acceso delegado por",
	returnToPreviousStep: "Volver a un paso anterior",
	backButtonWarning: "Si vuelve a un paso anterior y realiza cambios, su progreso en este paso puede verse afectado. <br> Seleccione <b>Continuar</b> para volver a un paso anterior o <b>Cancelar</b> para permanecer en este paso.",
	step1SubInstructionPart3: "Los clientes que seleccione en este paso determinarán qué compromiso de EY Canvas están disponibles para conectar el proyecto.",
	step3InstructionHeader: "Seleccione una o varios compromisos de EY Canvas y arrástrelas y colóquelas en el organigrama.",
	step3InstructionPara: "El vínculo entre los compromisos de EY Canvas y las entidades del organigrama determina cómo se resumen los datos de EY Canvas en el panel del proyecto.",
	availableLabel: "disponible",
	connectedLabel: "Conectado",
	milestoneSummaryView: "Milestione - vista resumida",
	taskCompletionByMilestone: "Finalización de tareas por milestone",
	basedOnTaskCompletition: "Basado en la finalización de la tarea",
	scopeAndStrategy: "Alcance & Estrategia",
	execution: "ejecución",
	conclusion: "conclusión",
	step3ListDefaultMessage: "No hay compromisos disponibles para los clientes seleccionados en el Paso 1. Vuelva al paso 1 y seleccione un cliente diferente para continuar.",
	addNewEngagementLabel: "Añadir nuevo compromiso",
	selectedLabel: "seleccionado",
	moreText: "más",
	connectLabel: "conectar",
	connectEngagements: "Compromisos conectados",
	connectToAnEngagement: "Conectar un compromiso para empezar",
	connectToAnAccessGroup: "No se ha conectado ningún grupo.",
	tasks: "Tareas",
	organizationalChartHeading: "Entidades",
	groupAdministratorsLabel: "Administradores de grupos",
	step4InstructionHeader: "Cree grupos para el proyecto y conéctelos a una o varias entidades del organigrama.",
	step4ImportantNote: "Nota importante: Los miembros de un grupo pueden ver los datos de engagement de EY Canvas para las entidades del organigrama conectadas con el grupo y los hijos de esas entidades. Si conectas un grupo a una entidad principal en tu organigrama, el grupo podrá ver los datos del engagement de EY Canvas para la entidad principal y todos sus elementos secundarios.",
	addAGroup: "Añadir un grupo",
	addGroup: "Añadir grupo",
	searchGroup: "Grupo de busqueda",
	addNewGroupHeader: "Cree un nuevo grupo aquí.",
	editNewGroupHeader: "Editar un grupo existente aquí.",
	addNewGroupInstruction: "Una vez creado el proyecto, puede invitar a miembros del equipo interno y externo a este grupo. Tiene la opción de agregar un administrador de grupo que también puede invitar a miembros a este grupo.",
	groupName: "Nombre del grupo",
	groupAdministrators: "Administradores de grupo (opcional)",
	groupAdministratorsSubHeading: "Agregue un administrador de grupo. Los administradores de grupo pueden invitar a miembros al proyecto después de crearlo. No puede editar las vistas y dominios de este grupo.",
	clearAllValues: "Claro",
	createGroupDashboardViews: "Vistas del panel",
	dashboardViewsSubHeading: "Seleccione al menos una vista. Esto determina los datos que los miembros pueden ver cuando ven el panel del proyecto.",
	duplicateDomain: "Dominio duplicado",
	allMilestones: "Todos los Milestiones",
	someMilestonesSelected: "{0} Milestones seleccionados",
	noGroupsAdded: "No se han agregado dominios a este proyecto.",
	step5InstructionHeader: "Revisa tu proyecto de EY Canvas Oversight.",
	step5SubInstruction: "Si necesita realizar cambios, seleccione el lápiz Editar para volver a un paso anterior. <b>Realizar cambios en un paso anterior puede afectar el progreso en pasos posteriores.</b>",
	associationNotRequired: "No se requiere asociación",
	accessGroupAlreadyAddedToParent: "Ya ha asociado uno o varios de los grupos seleccionados a una entidad primaria. Si un grupo de acceso está conectado a una entidad primaria, sus miembros pueden ver los datos de interacción de EY Canvas para la entidad primaria y todos sus elementos secundarios. Por lo tanto, no se requiere asociación.",
	deleteGroupInstructionalText: "¿Está seguro de que desea eliminar este grupo? <br>Una vez eliminada, la operación no se puede deshacer. Los miembros del grupo ya no podrán acceder a su proyecto.",
	deleteGroup: "Eliminar grupo",
	removeMember: "Remover un miembro",
	removeMemberTitle: "¿Está seguro de que desea eliminar a este miembro del equipo? Si el miembro pertenece a varios grupos, se quitará de todos los grupos enumerados aquí y es posible que ya no pueda acceder a este proyecto. Si solo desea quitar el miembro de un solo grupo, seleccione la opción <b>Editar</b> en su lugar.",
	teamMember: "Miembro del equipo",
	clientNameLbl: "Clientes",
	help: "Ayuda",

	//Org char left rail
	filters: "Filtros",
	countEngagementSelected: "{0} de {1} compromisos seleccionados",
	of: "{num} de",
	entityName: "Nombre de la entidad",
	enterEntityName: "Introduzca el nombre aquí",
	projectOwner: "Propietario del proyecto",
	role: "Rol",
	domains: "Dominios (opcional)",
	domainSubHeading: "Agregue al menos un dominio si se invitará a miembros externos del equipo a este grupo. Dominio se refiere a los caracteres después del símbolo @ en una dirección de correo electrónico. Para agregar un miembro del equipo externo, debe tener un dominio válido para este grupo.",
	addAdministrator: "Agregar un administrador de grupo",
	addNewDomain: "Agregar un nuevo dominio",
	addExistingDomain: "Añadir un dominio existente",
	placeholderStep3NoEngagementMessage: "No hay compromisos disponibles para los clientes seleccionados en el Paso 1. Vuelva al paso 1 y seleccione un cliente diferente para continuar.",
	placeholderStep3NoConnectedEngagementMessage: "Todavía no hay compromioss adjuntos.",
	placeholderStep3AllEngagementsConnected: "Todos los compromisos disponibles están conectados a su proyecto.",
	placeholderStep4NoConnectedGroupMessage: "Todavía no hay grupos conectados.",
	domainName: "Nombre de dominio",
	engagementLabel: "Compromiso",
	start: "empezar",
	end: "fin",
	suggestedEnd: "Fin sugerido",
	status: "Estado",
	thereIsNoDataToDisplay: "No hay datos que mostrar.",
	selectadditionalEntitiesToContinue: "Seleccione entidades adicionales para continuar.",
	comingSoonToDisplay: "El estatus de los componentes estará disponible pronto.",
	checkForUpdatesToDisplay: "Vuelva a consultar en las próximas semanas para obtener actualizaciones.",
	userSearchPlaceholder: "Introduzca el nombre o el correo electrónico y pulse Inter para ver los resultados.",
	userSearchPlaceholderForExternal: "Introduzca el correo electrónico y pulse enter para ver los resultados.",
	partnerInChargeInvitedToTheEngagement: "Socio a cargo invitado para el compromiso",
	partnerInChargeSignedOffOnCraSummary: "Socio responsable ha firmado el cra summary",
	eqrSignedOffOnCraSummary: "EQR ha firmado el  cra summary",
	partnerInChargeSignedOffOnAuditPlan: "Socio responsable ha firmado el plan de auditoría",
	picInvited: "PIC invitado",
	picSignOffCRA: "Firma de PIC en CRA",
	picSignOffAuditPlan: "Firma de PIC en el Plan de Auditoría",
	eqrSingOffCRA: "Firma de EQR en CRA",
	overdue: "vencido",
	outOf: "fuera de",
	edit: "Editar",
	remove: "eliminar",
	add: "agregar",
	admin: "Administradores",
	views: "Vistas",
	domainLabel: "dominio",
	domainslabel: "Dominios",
	viewLabelText: "vista",
	viewsLabelText: "Vistas",
	administrators: "Administradores",
	none: "Ninguno",
	organizationChart: "Organigrama",
	invalidDomainName: "Nombre de dominio no válido",
	lastRefreshed: "Última actualización",
	lastRefreshedActivityFeed: 'Activity feed data last refreshed',
	lastRefreshedReconciliation: "Datos de conciliación actualizados por última vez",
	quickFilter: "Filtro rápido",
	notApplied: "No aplica",
	quickFilterInput: "Nombre de filtro rápido",
	quickFilterSubHeaderText: "Cuando haya terminado, puede aplicar el filtro rápido para refinar las entidades para las que le gustaría ver los datos sin tener que seleccionar individualmente cada una.",
	createFilterTrigger: "Crear nuevo filtro",
	createFilterTitle: "Crear nuevo filtro rápido",
	createFilterButton: "Crear filtro rápido",
	createFilterHeaderText: "Seleccione una o más entidades de organigrama para crear un filtro rápido.",
	createFilterSubHeaderText: "Cuando haya terminado, puede aplicar el filtro rápido para refinar las entidades para las que le gustaría ver los datos sin tener que seleccionar individualmente cada una.",
	editFilterTitle: "Editar filtro rápido",
	editFilterHeaderText: "Editar o eliminiar filtro rapido",
	editFilterIconTitleTip: "Editar",
	oneRequired: "Se requiere al menos una selección.",
	noFiltersCreatedTitle: "Todavía no se han creado filtros rápidos.",
	noFiltersCreatedSubTitle: "Cree un filtro rápido para comenzar.",
	clear: "Claro",
	completionRange: "Rango de finalización",
	engagementCount: "Recuento de compromisos",
	clickOnAVisualBelowToFilterTheEngagementList: "Haga clic en un elemento visual a continuación para filtrar la lista de compromisos.",
	organizationalChartTooltip: "Seleccione Organigrama para editar o eliminar entidades de su proyecto de supervisión.",
	organizationalChart: "Organigrama",

	//Task status chart labels
	open: "abrir",
	inProgress: "En curso",
	inReview: "En revisión",
	completeUpperCase: "Completo",
	taskStatusOverdue: "Vencido",
	noDataForSelections: "No hay datos disponibles para sus selecciones.",
	selectOneOrMoreMilestones: "Seleccione uno o varios milestones diferentes para continuar.",
	milestoneDetailTitle: "Milestones - detalle",
	taskStatusByMilestone: "Estado de la tarea por milestone",
	milestoneDetailSubtitle: "Basado en el estado de la tarea",
	basedOnAllTasksForTheSelectedMilestone: "Basado en todas las tareas para el(los) milestone(s) seleccionado(s)",
	totalTasks: "total de tareas",
	noneSelected: "Ninguno seleccionado",
	nameOrEmail: "Nombre o correo electrónico",
	remove: "eliminar",
	milestonesTooltipText: "Progreso de Auditoría por Milestones",
	canvasClientPortalTooltipText: "Estado de la solicitud, incluidos los artículos vencidos, vencidos y devueltos",
	groudAuditTooltipText: "Estado del equipo y componente principal, incluidos los artículos devueltos y vencidos",
	projectManagementTooltipText: "Estado de las notas y asignaciones de revisión, incluidos los artículos vencidos. Esta vista no será visible para los clientes.",
	insightsTootipText: "Comparación de riesgos, procedimientos sustantivos, estrategia de control y hallazgos entre equipos primarios y componentes. Esta vista no será visible para los clientes.",
	reportTootipText: "Informar sobre el estado de preparación, modificación y finalización de tareas por país",
	taskStatusComplete: "Estado de la tarea: completada",
	taskStatusInreview: "Estado de la tarea: en revisión",
	taskStatusInprogress: "Estado de la tarea: en curso",
	taskStatusOpen: "Estado de la tarea: abiertas",

	//Review Notes chart labels
	reviewNotesByStatusTitle: "Todas las notas de revisión",
	byStatus: "Por estado",
	totalNotes: "total de notas",
	totalNotesLabel: "Total de notas",
	openNotes: "Abrir notas",
	byPriority: "Por prioridad",
	cleared: "Despejado",
	closed: "cerrado",
	low: "Bajo",
	medium: "Medio",
	high: "Alto",
	critical: "Crítico",
	notesTableTooltipContent: "Basado en notas con estatus Abierto",

	// Group audit
	groupAuditTotalForms: "Formularios totales",
	groupAuditNotSent: "No enviado",
	groupAuditUnlinked: "Desvinculado",
	totalTasksCapitalized: "Tareas totales",
	primary: "Primario",
	component: "Componente",

	//Bar chart
	are: "son",
	complete: "completar",
	noMilestoneDataForSelection: "No hay datos de milestones que mostrar para esta fase de auditoría.",
	selectDifferentAuditPhase: "Seleccione una fase de auditoría diferente o seleccione entidades adicionales para continuar.",

	//Delegate
	delegateInstruction: "Delega el acceso a otro miembro del equipo para que puedan crear proyectos en tu nombre. Introduce el nombre o la dirección de correo electrónico de un miembro del equipo para empezar. Sus delegados tendrán acceso a todos sus clientes.",

	delegateAccess: "Administrar delegados",
	addAnother: "Agregar delegados",
	hideMyDelegate: "Esconde a mis delegados",
	showMyDelegate: "Mostrar a mis delegados",
	noRecord: "No se han encontrado resultados",
	duplicateUser: "Delegado ya agregado",
	duplicateUserMessage: "Usuario ya agregado",
	addDelegates: "Agregar delegados",
	delegateTo: "Delegado a",
	delegateFrom: "Delegado de",
	delegateToMsg: "No ha delegado su acceso a ningún miembro del equipo.",
	delegateFromMsg: "Ningún miembro del equipo ha delegado su acceso a usted.",

	// Project dashboard left rail
	searchFilterPlaceholder: "Filtros de búsqueda",
	searchEntitiesPlaceholder: "Entidades de búsqueda",
	outOfEngagements: "<b>{0}</b> fuera de <b>{1}</b> Compromisos",
	engagementCompletedBasedOnTaskCompletion: "<b>{0}</b> Compromiso es <b>{1}</b> basa en la realización de la tarea",
	engagementsCompletedBasedOnTaskCompletion: "<b>{0}</b> compromisos <b>{1}</b> han sido completados en función de la finalización de la tarea",
	engagementCompletedBasedOnTaskCompletionReporting: '<b>{0}</b> engagement has completed <b>{1}</b> of tasks',
	engagementsCompletedBasedOnTaskCompletionReporting: '<b>{0}</b> engagements have completed <b>{1}</b> of tasks',
	engagementCompletedBasedOnTaskCompletionMilestone: '<b>{0}</b> engagement has completed <b>{1}</b> of tasks for this milestone',
	engagementsCompletedBasedOnTaskCompletionMilestone: '<b>{0}</b> engagements have completed <b>{1}</b> of tasks for this milestone',
	reportReleaseDate: "Fecha de publicación del informe",
	partnerInvited: "Socio invitado",
	picSignoffOnCra: "Pic ha firmado el CRA",
	eqrSignoffOnCra: "EQR ha firmado el CRA",
	picSignoffOnAuditPlan: "PIC a firmado el plan de auditoría",
	overdueLabel: "Vencido",

	//Team members
	teamMembersTitle: "Miembros del equipo",
	membersTitle: "Miembros",
	eyContactsTitle: "Contactos de EY",
	allMembersLabel: "Todos los miembros",
	internalMembersLabel: "Miembros internos",
	externalMembersLabel: "Miembros externos",
	groupsTitle: "Mis grupos",
	projectOwnersTitle: "Propietarios de proyectos",
	projectOwnersLabel: "Propietarios de proyectos",
	projectOwnerLabel: "Dueño del proyecto",

	//CCP
	summary: "resumen",
	requestsByStatus: "Solicitudes por estatus",
	totalRequests: "pedidos totales",
	totalRequestsTitle: "Solicitudes totales",
	receivedByEy: "Recibido por EY",
	acceptedByEy: "Aceptado por EY",
	outstandingByEy: "Excelente",
	returned: "Devuelto",
	receivedByEyOnTime: "Recibido por EY a tiempo",
	averageDaysOverdue: "Promedio de días vencidos",
	outOfReceivedAndAccepted: "<b>{0}</b> de <b>{1}</b> solicitudes recibidas y aceptadas",
	outOfStandingRequests: "<b>{0}</b> de <b>{1}</b> solicitudes pendientes",
	outOfAverageDaysOverdue: "<b>{0}</b> de <b>{1}</b> solicitudes pendientes",
	draftRequests: "{0} de solicitudes de borrador",
	noResultMessageHeader: "No hay datos que mostrar. Seleccione entidades adicionales para continuar.",
	noResultMessageSubHeader: '',
	members: "Miembros",
	memberLabel: "miembro",
	adminLabel: "Administrador",
	projectOwnerLabel: "Propietario del proyecto",
	viewsLabel: "Vistas",
	metrics: "Métricas",
	yes: "Sí",
	no: "No",
	emptyMessageAvailableGroup: "Todavía no se han creado grupos. <br>Seleccione <b>Agregar un grupo</b> para empezar.",
	thereIsNoDataToDisplayForThisEntity: "No hay datos para mostrar para esta entidad.",
	typeLabel: "tipo",
	groupsLabel: "grupos",
	group: "grupo",
	entitiesLabels: "Entidades",
	entityLabel: "Entidad",
	nameLabel: "nombre",
	searchTeamMembers: "Miembros del equipo de búsqueda",
	notSelectedLabel: "No seleccionado",
	entitiesLabel: "Entidades",
	noDataAvailableLabel: "No se dispone de datos.",
	delete: "borrar",
	deleted: "Borrado",
	addAMember: "Agregar un miembro",
	addMemberHeaderText: "Agregue un nuevo miembro a uno o varios grupos del proyecto.",
	teamMemberInformation: "Información de los miembros del equipo",
	teamMemberNote: "Escriba el nombre o el correo electrónico del miembro interno o externo del equipo que desea agregar a los grupos seleccionados. Pulse la tecla Intro para ver los resultados.",
	selectGroupNote: "Seleccione al menos un grupo. Los miembros del grupo pueden ver los datos del compromiso de EY Canvas para todas las entidades del organigrama a las que están conectados sus grupos, así como para cualquier componente secundario de esas entidades.",
	inviteAndClose: "Invitar y cerrar",
	inviteAndAddAnother: "Invitar & agregar otro",
	contacts: "Contactos",
	email: "Correo electrónico",
	emailAll: "Enviar un correo electrónico a todos",
	contactTeam: "Equipo de contacto",
	emptyMessage: "No hay contactos disponibles para este compromiso.",
	comingDue: "Vencen",
	tomorrow: "mañana",
	next3days: "Próximos 3 días",
	next5days: "Próximos 5 días",
	next10days: "Próximos 10 días",
	next30days: "Próximos 30 días",
	comingDueNext5days: "Vencimiento (próximos 5 días)",
	entityDetails: "Detalles de la entidad",
	requestsByEntity: "Solicitudes por entidad",
	basedOnTheSelectedCategory: "Basado en la categoría seleccionada",
	requestCount: "Recuento de solicitudes",
	selectedDay: "Día seleccionado",
	editMember: "Editar miembro",
	editMemberHeaderText: "Edite los grupos a los que tiene acceso el miembro del equipo seleccionado.",
	editaGroup: "Editar grupo",
	editAGroupHere: "Editar un grupo aquí",
	selectAnotherFrame: "Seleccione otro período de tiempo para ver los datos.",
	emptyFrameShort: "Seleccione entidades adicionales para continuar.",
	emptyFrame: "Seleccione entidades adicionales o un período de tiempo diferente para continuar.",
	editMemberHeaderText: "Edite los grupos a los que tiene acceso el miembro del equipo seleccionado.",
	confirm: "confirmar",
	markCompleteModalInstrTextPart1: "¿Está seguro de que desea completar este proyecto?",
	markCompleteModalInstrTextPart2: "Una vez que realice esta acción, no se puede deshacer. Los proyectos completados se pueden actualizar y usar como plantilla al crear un nuevo proyecto.",
	firstPage: "Primera página",
	lastPage: "Última página",
	nextPage: "Página siguiente",
	prevPage: "Página anterior",

	// Add Tag
	keyContacts: "Contactos clave",
	customTags: "Etiquetas personalizadas",

	// Manage Tags
	manageTagInstructional: "Cree nuevas etiquetas personalizadas aquí. También puede editar y eliminar etiquetas personalizadas existentes. Etiquetar contactos le brinda la flexibilidad de administrar contactos en su proyecto de supervisión de EY Canvas.",
	emptyCustomTagsList: "Aún no se han creado etiquetas personalizadas.",
	manageTagTitle: "Administrar etiquetas personalizadas",
	manageTagLinkButton: "Administrar etiquetas",
	color: "Color",
	tagName: "Nombre",
	tagDelete: "Borrar",
	tagCreate: "Crear nueva etiqueta",
	customTagsHeader: "Etiquetas personalizadas",

	//preparer assignment tile
	totalPreparerAssignments: "total de asignaciones de preparadores",
	inprogress: "En progreso",
	preparerAssignments: "Asignaciones de preparador",
	byAssignmentStatus: "Por estado de asignación",
	taskWithoutPreparerAssignments: "sin asignaciones de preparador",
	tasksWithoutPreparerAssignments: "tareas sin asignaciones de preparador",
	preparerFilterTitle: "Preparador",

	// reviewer assignment tile
	totalReviewerAssignments: "total de asignaciones de revisores",
	taskWithoutReviewerAssignments: "tarea sin asignaciones de revisor",
	tasksWithoutReviewerAssignments: "tareas sin asignaciones de revisor",
	reviewerFilterTitle: "Revisor",

	assignments: "Asignaciones",
	notes: "Notas",
	preparerNotAssigned: "Preparador no asignado",
	reviewerAssignments: "Asignaciones de revisores",
	reviewerNotAssigned: "Revisor no asignado",
	basedOnPreparerAssignments: "Basado en asignaciones de preparadores",
	basedOnPreparerAssignmentsOpenAndInProgress: "Basado en asignaciones de preparador con estado Abierto y En curso",
	basedOnReviewerAssignments: "Basado en asignaciones de revisores",
	basedOnReviewerAssignmentsOpenAndInProgress: "Basado en asignaciones de revisor con estado Abierto y En curso",

	statusOpen: "Estatus - Abierto",
	statusInProgress: "Estatus - En curso",
	statusClosed: "Estatus - Cerrado",
	byPriorityLow: "Por prioridad - Baja",
	byPriotityMedium: "Por prioridad - Media",
	byPriorityHigh: "Por prioridad - Alta",
	byPriorityCritical: "Por prioridad - Crítica",

	findingsLabel: "Resultados",
	riskLabel: "Riesgos",
	digitalAuditLabel: "Auditoría digital",
	digitalAuditStrategy: "Estrategia de auditoría digital",
	byDigitalAuditTypeLabel: "Por estrategia de auditoría digital",
	basedOnProfileSelection: "Basado en la selección de perfiles",
	basedOnSelectionArchiveForm: "Basado en la selección en el formulario de archivo.",
	MisstatementsByType: "Inexactitudes por tipo",
	DeficienciesBySeverity: "Deficiencias por gravedad",
	MisstatementsLabel: "Declaraciones erroneas",
	DeficienciesLabel: "Deficiencias",
	primarTeamDeficiencyHeader: "Equipos primarios - {0}",
	componentRegionalTeamDeficiencyHeader: "Equipos regionales y de componentes - {0}",
	auditTileHeaderTextPrimary: "Equipos primarios - {0}",
	componentRegionalTeamHeader: "Equipos regionales y de componentes - {0}",
	allTeamDeficiencyHeader: "Todos los compromisos - {0}",
	primarTeamMisstatementHeader: "Equipos primarios - {0}",
	componentRegionalTeamMisstatementHeader: "Equipos regionales y de componentes - {0}",
	allTeamMisstatementHeader: "Todos los compromisos - {0}",
	deficiencyLabel: "Deficiencia",
	inherenRisktLabel: "Riesgo de error material",
	significantRiskLabel: "Significativo",
	fraudRiskLabel: "Fraude",
	significantDeficiencyLabel: "Deficiencia significativa",
	materialWeaknessLabel: "Debilidad material",
	factualLabel: "Fáctico",
	projectedLabel: "Proyectado",
	judgmentalLabel: "Crítico",
	reclassificationLabel: "Reclasificación",
	totalDeficiencyLabel: "deficiencia total",
	totalRiskLabel: "riesgo total",
	totalRisksLabel: "riesgos totales",
	totalDeficienciesLabel: "deficiencias totales",
	totalMisstatementLabel: "inexactitud total",
	totalMisstatementsLabel: "inexactitudes totales",
	allEngagementHeader: "Todos los compromisos - {0}",
	noAuditSightGroupData: "<b>No hay que mostrar datos de auditoría de grupo.</b> <br>Seleccione <b>Todos los </b>de la alternancia para ver los datos resumidos.",
	noAuditTileDataPlaceholder: "No hay datos que mostrar. Seleccione entidades adicionales para continuar.",
	openReviewNotes: "Abrir notas de revisión",
	byPriorityLevel: "Por prioridad",
	risks: "Riesgos",
	groupRoleLabel: "Rol del grupo",
	totalRisks: "Riesgos totales",
	byType: "Por tipo",
	inherent: "Riesgo de error material",
	significant: "Significativo",
	fraud: "Fraude",
	strategy: "Estrategia",
	notApplicable: "No aplicable",
	customizableTable: "Personalizar tabla",
	selectUpToOptionHeader: "Seleccionar hasta {0} opciones",
	selectUpToThreeOptionHeader: "Seleccione hasta tres opciones",
	selectUpToFourOptionHeader: "Seleccione hasta cuatro opciones",
	psps: "PSP",
	osps: "OSP",
	hxpsps: "HxPSPs",
	totalSubstantiveProcedures: "total de procedimientos sustantivos",
	totalSubstantiveProcedure: "total de procedimientos sustantivos",
	totalITControls: " total de ITGCs e ITSPs",
	totalITControl: "total itGC e ITSP",
	testing: "Probando",
	nonTesting: "No probando",
	auditStrategy: "Estrategia de auditoría",
	totalControls: "controles totales",
	totalControl: "controles total",
	removeProject: "Eliminar proyecto",
	removeProjectInstructionalText: "¿Está seguro de que desea eliminar el siguiente proyecto de su lista de proyectos activos? <br>Si quita el proyecto, ya no podrá acceder a él.",
	substantiveProcedures: "Sustantivo",
	controls: "Controles",
	itlabel: "IT",

	//delegates removed
	userDelTitle: "Mis delegados",
	delTitleDetail: "Ha delegado su acceso a los miembros del equipo que se enumeran aquí. Sus delegados tienen acceso a todos los clientes a los que tiene acceso.",
	delElseMsg: "No has añadido a ningún delegado todavía.",
	delegateTitle: "Eliminar un delegado",
	delegateMember: "Delegado",
	deleteMessage: "¿Está seguro de que desea eliminar a este delegado? <br/> Una vez eliminado, ya no podrá crear proyectos en su nombre.",

	//Advanced filters.
	advancedFilters: "Filtros avanzados",
	selectAll: "Seleccionar todo",
	deselectAll: "Deseleccionar todo",
	applyFilters: "Aplicar filtros",
	region: "Región",
	country: "País",
	city: "Ciudad",
	state: "Estado",
	advancedFiltersInstructionalText: "Seleccione las entidades para las que desea ver los datos de participación.",
	advancedFiltersInstructionalTextLine2: "Las entidades a las que no tiene acceso aparecen deshabilitadas. Hable con un administrador de grupo si necesita acceso.",
	engagementsSelected: "compromiso (s) seleccionado (s)",
	filterYes: "Si",
	filterNo: "No",

	//Group Audit
	pendingResponse: "Respuesta pendiente",
	primaryTileTitle: "Estatus del equipo primario",
	reportingFormStatus: "Informe por estatus",
	reportingForm: "Formulario de reportes",
	summarizedForPrimaryTeams: "Resumido para equipos primarios",
	primaryTileSubtitle: "formularios de informes de grupo enviados",
	received: "Recibido",
	dueToPrimaryTeam: "Debido al equipo primario",
	sentToPrimaryTeam: "Enviado al equipo primario",
	evidencePending: "Evidencia pendiente",
	evidenceComplete: "Evidencia completa",
	componentTileTitle: "Estatus del equipo del componete",
	componentTaskStatus: "Estado de la tarea del componente",
	componentTask: "Tarea de componente",
	comingsoonTaskStatus: "Próximamente",
	summarizedForComponentTeams: "Resumido para equipos de componentes",
	componentTileSubtitle: "tareas de auditoría de grupo recibidas",
	unlinkedTask: "Tarea desvinculada",
	unlinkedTasks: "Tareas desvinculadas",

	//Group Risk Assessment
	groupRiskAssessmentTitle: "Riesgos",
	groupRiskSummaryTitle: "Evaluación de riesgos grupales",

	// Reporting
	reportModifications: "Reporte de modificaciones",
	byReportType: "Por tipo de reporte",
	notSelected: "No seleccionado",
	unmodified: "No modificado",
	modified: "Modificado",
	reports: "Reportes",
	opinions: "Opiniones",
	modifiedReports: "Reportes modificados",
	modifiedOpinions: "Opiniones modificadas",
	adverse: "Adversa",
	disclaimer: "Abstención",
	qualification: "Calificación",
	qualified: "Calificado",
	engagementReportTooltip: "Aquí solo se resumen los compromisos con fechas de informe anteriores a la fecha actual. Todos los compromisos se muestran en la siguiente tabla.",
	geography: "Geografía",
	standars: "Estándares",
	gaap: "GAAP",
	gaapUs: "GAAP US",
	ifrs: "IFRS",
	other: "Otros",
	yearEndDate: "Fecha de fin de año",
	endDateOfPeriodCovered: "Fecha de finalización del período cuberto",
	reportDate: "Fecha de reporte",
	archiveDeadline: "Fecha limite de archivo",
	reportType: "Tipo de reporte",
	opinionType: "Tipo de opinión",
	taskStatus: "Estatus de tarea",
	exportData: "Exportar datos",
	exportToExcel: "Exportar",
	orgChartEntity: "Entidad de organigrama",
	engagementId: "ID del compromiso",
	contactName: "Nombre contacto",
	contactEmail: "Correo del contacto",
	statusInherent: 'By Type - Risk of material misstatement',
	statusSignificant: "Por tipo - Significativo",
	statusFraud: "Por tipo - Fraude",
	substantivePSPs: "Sustantivo - PSPs",
	substantiveOSPs: "Sustantivo - OSPs",
	substantiveHxPSPs: "Sustantivo - HxPSPs",
	controlsTesting: "Controles - Pruebas",
	controlsNonTesting: "Controles - Sin pruebas",
	iTTesting: "IT - Pruebas",
	iTNonTesting: "IT - Sin pruebas",
	misstatementsFactual: "Declaraciones erróneas - Fácticas",
	misstatementsProjected: "Declaraciones erróneas - Proyectadas",
	misstatementsJudgmental: "Declaraciones erróneas - De juicio",
	misstatementsReclassification: "Declaraciones erróneas - Reclasificaciones",
	deficienciesDeficiency: "Deficiencias - Deficiencia",
	deficienciesSignificantdeficiency: "Deficiencias - Deficiencia significativa",
	deficienciesMaterialweakness: "Deficiencias - Debilidad material",
	statusComplete: "Estatus - Completo",
	statusInReview: "Estatus - En revisión",
	statusInProgress: "Estado - En curso",
	statusOpen: "Estatus - Abierto",
	statusNotSent: "Estatus - No enviado",
	statusReturned: "Estatus - Devuelto",
	statusDocumentationPending: "Estatus - Documentación pendiente",
	statusDocumentationComplete: "Estado - Documentación completa",
	statusReceivedbyEY: "Estado - Recibido por EY",
	statusAcceptedbyEY: "Estado - Aceptado por ey",
	statusOutstanding: "Estado - Pendiente",
	noCompletedProjectsMessagePart1: "No tienes ningún proyecto completo.",
	noCompletedProjectsMessagePart2: "Si es propietario de un proyecto, puede marcar un proyecto como completado. Los proyectos completados se pueden avanzar y usar como plantilla al crear un nuevo proyecto.",
	noCompletedProjectsMessage: "No tiene ningún proyecto completado. <br>Si usted es propietario de un proyecto, puede marcar el proyecto completado. Se puede hacer roll forward en los proyectos completados y usar como plantilla al crear un nuevo proyecto.",
	requests: "Solicitudes",

	//Reporting readiness report
	week: "semana",
	weeks: "semanas",
	readinessReportTitle: "Reportar la preparación",
	taskCompletionByEngagement: "Finalización de tareas por compromiso",
	readinessLegendTitle: "Proximidad a la fecha de informe",
	basedOnReportDateProximityForEachEngagement: "Basado en la proximidad de la fecha del informe para cada compromiso",

	//ReportCompletion
	taskCompletionStatus: "Estatus de tarea terminada",
	taskCompletionByLocation: "Finalización de tareas por ubicación",
	basedOnCompletedTasksForEachEngagement: "Basado en las tareas completadas para cada compromiso",
	byGeography: "Por geografía",
	taskCompletion: "Tarea terminada",
	completedTasks: "Tareas completas",

	engagementArchived: "Este compromiso ha sido archivado. Los datos ya no están disponibles.",
	externalUsersNoActiveProjMessage: "No tienes ningún proyecto activo. Habla con un miembro de EY Equipo para obtener acceso.",

	//Error Messages
	networkErrorMessage: "La red de aplicaciones está experimentando un error. Actualice la página e inténtelo de nuevo más tarde. Póngase en contacto con el servicio de asistencia si el error persiste.",
	genericErrorMessage: "La operación seleccionada no se pudo completar en este momento. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
	otherProjectPlaceholder: "Sus compromisos de EY Canvas están conectados a los proyectos de supervision de EY Canvas que se enumeran aquí. No tiene acceso a estos proyectos. Comuníquese con el propietario del proyecto o administrador de grupo para obtener acceso.",
	noProjectsAvailable: "No hay proyectos disponibles.",
	completedProjectPlaceholder: "Sus proyectos de EY Canvas Oversight finalizados se enumeran aquí. Seleccione la opción <b>rodar hacia adelante </b> para usar el proyecto completado como plantilla al crear un nuevo proyecto.",
	completedNotProjectPlaceholder: "No tiene ningún proyecto completado. <br>Si usted es propietario de un proyecto, puede marcar el proyecto como completado. Los proyectos completados se pueden usar como plantilla al crear un nuevo proyecto.",

	//Log out and time out modal
	logoutModalTitle: "Cierre automático para su protección",
	sessionTimerMsgLine1: "Debido a la inactividad, su sesión de trabajo actual está a punto de expirar.",
	sessionTimerMsgLine2: "Para su seguridad, las sesiones de supervisión del EY Canvas se cerraran automáticamente después de 30 minutos de inactividad.",
	sessionTimerMsgLine3: "Su sesión actual caducará en {0} minutos.",
	sessionTimerMsgLine4: "Si desea permanecer conectado, haga clic en",
	modalContinueButton: "<b> continuar </ b>",
	modalLogoutButton: "Cerrar sesión",
	modalCloseButton: "Cerrar",
	countryNotAvailable: "País no disponible",
	regionNotAvailable: "Región no disponible",
	notAvailable: "No disponible",
	signout: "Cerrar sesión",
	engagementTypeNotAvailable: "Tipo de compromiso no disponible",

	// Admin portal
	administration: "Administración",
	mainPageInstructionalText: "Bienvenido al Portal Administrativo de EY Canvas Oversight",
	manageProjectsFormatted: "Administrar <br />projects",
	manageUsersFomatted: "Administrar <br />users",
	manageAdminsFormatted: "Manejo <br /> de administradores de Oversight",
	homeLabel: "Inicio",
	userNotFoundError: "Usuario no encontrado.",
	manageUsersInstructionalText: "Busque un usuario ingresando su GUI",
	selectRole: "Seleccionar rol",
	role: "Rol",

	//Manage User
	manageUsersTitle: "Manejar usuarios",
	otherProjectsTabTitle: "Otros proyectos",
	validGuiErrorMsg: "Introduzca una GUI válida",
	accessibleProjects: "Proyectos accesibles",
	delegates: "Delegados",
	projectID: "ID del proyecto",
	projectStatus: "Estatus del proyecto",
	gui: "GUI",
	emailAddress: "Dirección de correo electrónico",
	userRole: "Rol de usuario",
	userID: "ID de usuario",
	noResultMessage: "Ningún resultado coincide con los criterios de búsqueda.",
	noResultFound: "No se encontraron registros.",
	userDetails: "Datos del usuario",
	active: "Activo",
	inActive: "Inactivo",
	manageAdmins: "Manejar administradores de EY Canvas Oversight",
	manageAdminsInstructionalText: "Todos los administradores EY Canvas Oversight se enumeran a continuación. Puede editar los roles de un administrador, agregar y quitar administradores.",
	adminReader: "Lector de administración de aplicaciones",
	adminWriter: "Escritor de administración de aplicaciones",
	superAdmin: "Superadministrador de aplicaciones",
	revertChanges: "Revertir cambios",
	unSavedChanges: "Cambios no guardados",
	unSavedChangesMessage: "Tiene cambios no guardados que se perderán si continúa. <br/> Seleccione <b>Confirmar</b> para continuar. Seleccione <b>Cancelar</b> para volver a la página subyacente y guardar los cambios.",
	addNewAdmin: "Agregar nuevo administrador",
	addEYContactInstructions: "Introduzca un nombre o una dirección de correo electrónico y pulse Intro para ver los resultados. Seleccione un rol para agregar un nuevo administrador de Oversight.",

	// ManageProjects
	orgChartEntities: "Organigrama de entidades",
	manageProjectsInstructionalText: "Busque un proyecto introduciendo el ID del proyecto.",
	projectDetails: "Detalles del proyecto",
	parentEntity: "Entidad matriz",
	connectedGroups: "Grupos conectados",
	validProjectIDError: "Introduzca un ID de proyecto válido",
	addNewMember: "Agregar miembro",
	adminAddMemberInstructionalText: "Busque un usuario y seleccione los grupos a los que debe agregarse.",
	currentApplication: "Aplicación actual",

	//Software Update
	softwareUpdate: "Actualizaciones de software",
	updateNow: "Actualiza ahora",
	updateMsg: "Hay actualizaciones de software disponibles para EY Canvas Oversight. Seleccione Actualizar ahora para descargar e instalar actualizaciones. La página se actualizará.",

	//ContactDB
	placeholderForSearch: "Buscar",
	contactClearAll: "Borrar todo",
	contactShowMoreFilters: "más",
	contactListFilter: "Acceso a la lista de contactos",
	dashboardAccessFilter: "Acceso al Tablero",
	groupRoleFilter: "Rol del grupo",
	tagFilter: "Etiquetas",
	countryFilter: "País",
	serviceLineFilter: "Linea de servicio",
	typeFilter: "Tipo",
	roleFilter: "Rol",
	dashboardAccess: "Panel de acceso",
	contactList: "Lista de contactos",
	noEntitiesMessage1: "No hay datos para mostrar.",
	noEntitiesMessage2: "Seleccione entidades adicionales para continuar.",
	noContacts: "No hay contactos para esta entidad.",
	engagementsContacts: "Proyectos",
	manuallyAdded: "Agregado manualmente",
	dashboardViews: 'views',
	columnName: "Nombre",
	columnEmail: "Correo electrónico",
	columnEngagement: "Proyectos",
	columnType: "Tipo",
	columnRole: "Rol",
	columnServiceLine: "Línea de servicio",
	columnDashboard: "Acceso al Tablero",
	columnDashboardView: "Vistas de panel",
	columnContactList: "Acceso a la lista de contactos",
	columnTags: "Etiquetas",
	columnEntity: "Entidad",
	noResults: "No se encontraron resultados",
	noResultsAvailable: "No hay datos disponibles.",
	searchContacts: "Buscar contactos",
	selectedContacts: "Contactos seleccionados",
	tag: "Marcado",
	manageAccess: "Administrar el acceso",
	formLengthMessage: "El texto no puede superar {number} caracteres.",
	viewMoreColumns: "Ver más columnas",
	projectOwnerBadge: "Propietario del proyecto",
	entityAdminBadge: "Administrador de la entidad",
	eyTeam: "Equipo de EY",
	clientTeam: "Equipo del cliente",
	userProfile: "Perfil de usuario",
	columnGroupRiskAssessment: "Acceso a la evaluación de riesgos del Grupo",
	externalUserDenyMessage: 'External users cannot be granted access to the Group risk assessment module.',
	//ContactDB - Toolbar
	toolbarAddContact: "Agregar contacto",
	toolbarAccessLog: "Registro de acceso",
	toolbarMessageLog: "Registro de mensajes",
	toolbarCustomizeTable: "Personalizar tabla",
	toolbarExportData: "Exportar datos",
	toolbarManageAccess: "Administrar el acceso",
	toolbarDefineAttributes: "Definir atributos",
	toolbarGenerateMessage: "Generar mensaje",
	toolbarTags: "Etiquetas",
	toolbarRemove: "Eliminar",

	//ContactDB - Add Contact Modal
	addContactLabel: "Agregar contacto",
	addContactTitle: "Agregar contactos",
	addContactInstructional: "Agregue uno o más contactos a su proyecto EY Canvas Oversight. Si los contactos que está agregando requieren acceso al panel o la lista de contactos, puede otorgarles acceso aquí.",
	columnEntities: "Entidades",
	noEntities: "Ninguno",
	duplicatedUser: "ya se ha agregado como contacto. Puede administrar su acceso desde la lista de contactos.",
	accessToDashboard: "Acceso al panel de control",
	dashBoardsViews: "Acceso y vistas del panel de control",
	placeholderEntities: "Entidades",
	placeholderAccess: "Acceso",
	placeholderAttributes: "Atributos",
	placeholderTags: "Etiquetas",
	projectOwnerAccessLabel: "Acceso del propietario del proyecto",
	entityAdminAccessLabel: "Acceso de administrador de entidad",
	accessToContactListLabel: "Acceso a la lista de contactos",
	saveContactLabel: "Guardar",
	cancelContactLabel: "Cancelar",
	noContactsAdded: "Aún no se han agregado contactos.",
	noCustomColumns: "No se han creado columnas personalizadas para su proyecto.",
	toggleContactYes: "Sí",
	toggleContactNo: "No",
	mustSelectOneEntity: "Debe seleccionar al menos una entidad para continuar.",
	mustSelectOneView: "Seleccione al menos una vista para todos los contactos a los que está otorgando acceso al panel de EY Canvas Oversight",
	mustBeOnwerOrAdministrator: "Debe ser propietario del proyecto o administrador de la entidad para realizar esta acción. Actualice las entidades seleccionadas para continuar.",
	cannotEditAccessForProjectOwners: "No puede editar el acceso para los propietarios del proyecto: {list}",
	attributesLabel: "Atributos",
	externalUserDomainMismatch: "El dominio no está permitido para una o más entidades seleccionadas. Agregue los dominios requeridos en el flujo de configuración de la entidad y vuelva a intentarlo.",
	projectOwnerAccessToogleInfo: "El propietario de un proyecto tiene permisos completos para un proyecto EY Oversight",
	entityAdminAccessToogleInfo: "Un administrador de entidad tiene permisos específicos de entidad para realizar tareas administrativas, según sea necesario.",

	//ContactDB-CustomizeTable Modal
	customizeTableModal: "Personalizar tabla",
	InstructionalTextCustomizeTableModal: "Seleccione las columnas que desea ver.",
	cancelCustomizeTable: "Cancelar",
	saveCustomizeTable: "Guardar",
	tooltipCustomizeTable: "Personalizar tabla",
	standardColumns: "Columnas estándar",
	customColumns: "Columnas personalizadas",
	closeTitleModal: "cerrar",
	addCustomColumn: "Agregar columna personalizada",
	editCustomColum: "Editar columna personalizada",
	addCustomColumnLegend: "Las columnas personalizadas le permiten capturar y administrar atributos adicionales sobre sus contactos. Puede crear hasta cinco columnas personalizadas para su proyecto. Después de crear una columna, puede seleccionar uno o más contactos y definir un atributo. Si elimina una columna personalizada, también se eliminarán los atributos de los contactos.",
	deleteCustomColumnLegend: "Seleccione el icono <b>Eliminar</b> para eliminar una columna personalizada. Si continúa, ya no estará disponible para su proyecto. También se eliminará cualquier atributo que haya aplicado anteriormente a los contactos.",
	customColumnName: "Nombre de la columna",
	attribute: "Atributo",
	attributes1to5: "Atributos (1-5)",
	visibleToExternal: 'Visible para contactos externos',

	//ContactDB - Add Contact Modal
	filterTooltip: "Filtrar",
	searchTitletip: "Buscar",
	addExternalContactColumnName: "Nombre",
    addExternalContactColumnDomain: "Dominio",
	confirmDomain: "Confirmar dominio",

	//ContactDB - Profile Modal
	profileModalTitle: "Perfil",
	profileModalAccessSection: "Acesso",
	profileModalCustomAttributesSection: "Atributos personalizados",
	profileModalDashboardSection: "Vistas del tablero",

	//ContactDB - Generate Message
	selectMessageRecipients: "Seleccionar destinatarios del mensaje",
	notification: "Notificación",
	generateMessage: "Generar mensaje",
	gmInstructionalText: "Envía un correo electrónico o una notificación a los contactos que hayas seleccionado. Las notificaciones solo se pueden enviar a contactos internos. Los correos electrónicos se pueden enviar a contactos internos y externos.",
	messageType: "Tipo de mensaje",
	messageRecipient: "Destinatarios del mensaje",
	selectContactsNow: "Seleccione contactos ahora",
	useSelectedContacts: "Usar contactos seleccionados",
	moreFilters: "+ Más filtros",
	countries: "Países",
	groupRoles: "Rol del Grupo",
	groupRole: "Rol de grupo",
	roles: "Roles",
	role: "Rol",
	serviceLines: "Líneas de servicio",
	serviceLine: "Línea de servicio",
	contatcs: "Contactos",
	singularContact: "Contacto",
	singularEngagement: "Proyecto",
	allContact: "Todos los contactos",
	allEntitles: "Todas las entidades",
	allCountries: "Todos los países",
	allGroupRoles: "Todos los roles del grupo",
	allEngagements: "Todos los proyectos",
	allServicesLines: "Todas las líneas de servicio",
	allRoles: "Todos los roles",
	subject: "Asunto",
	removeTooltip: "Remover",
	fromEntity: "Desde la entidad",
	fromEngagement: "Desde proyecto",
	notificationMessage: "Mensaje de notificación",
	linkLabel: "Etiqueta de link (opcional)",
	link: "Link (opcional)",
	fromEntityNotification: "Desde la entidad",
	mustSelectOne: "Debe seleccionar al menos un contacto para continuar.",
	emailSentMsg: "Se ha generado un mensaje de correo electrónico para los contactos seleccionados.",
	notificationSentMsg: "Se ha enviado una notificación a los contactos seleccionados.",
	messageFrom: "Mensaje de",
	duplicateMessage: "Mensaje duplicado",
	someEntities: '{0} entities selected',

	//ContactDB - Message Log
	messageLogInstruction: "Revise la lista de mensajes enviados por su entidad. Si necesita enviar un mensaje de seguimiento, tiene la opción de duplicar los mensajes anteriores.",
	messageLogTitle: "Registro de mensajes",
	today: "Hoy",
	yesterday: "Ayer",
	thisWeek: "Esta semana",
	lastWeek: "La semana pasada",
	twoWeeksAgo: "Hace dos semanas",
	older: "Más antiguo",
	notificationTo: "Notificación para",
	emailTo: "Correo electrónico a",
	sentBy: "Enviado por",
	from: "Desde",
	date: "Fecha",
	time: "Tiempo",
	subject: "Asunto",
	multiContatcsLowerCase: "contactos",
	singleContactLowerCase: "contacto",
	seeMore: "Ver más",
	seeLess: "Ver menos",
	messageLogEmptyMessage: "Todavía no se han enviado mensajes.",
	messageLogFileExported: "Registro de mensajes",
	typeColumnToExportToExcel: "Tipo",
	sentByColumnToExportToExcel: "Enviado por",
	fromColumnToExportToExcel: "De",
	dateColumnToExportToExcel: "Fecha",
	timeColumnToExportToExcel: "Tiempo",
	subjectColumnToExportToExcel: "Sujeto",
	contactsColumnToExportToExcel: "Contactos",
	emailExportToExcel: "Correo electrónico",
	notificationExportToExcel: "Notificación",

	//ContactDB - Access Log
	accessLog: "Registro de acceso",
	accessLogInstructional: "Revise los miembros del equipo que se presentan a continuación y decida si desea agregarlos o eliminarlos como contactos.",
	addAll: "Añadir todo",
	removeAll: "Eliminar todo",
	ignoreAll: "Ignorar todo",
	contactsToAddEmpty: "No hay contactos potenciales para agregar en este momento.",
	contactsToRemoveEmpty: "No hay contactos potenciales para eliminar en este momento.",
	ignore: "Ignorar",
	addAllConfirmationModal: "Uno o más usuarios tienen un dominio que no está permitido por una entidad. Haga clic en Continuar para agregar los usuarios a la lista de contactos. El dominio(s) se importará(n) y agregará(n) a la lista de dominios permitidos para la entidad.",
	addConfirmationModal: "El usuario tiene un dominio que no está permitido por esta entidad. Haga clic en Continuar para agregar el usuario a la lista de contactos. El dominio será importado y agregado a la lista de dominios permitidos para la entidad.",

	// ContactDB - Message Log - Filter
	messageTypeFilter: "Tipo de mensaje",
	sentByFilter: "Enviado por",
	fromEntityFilter: "De la entidad",
	toEntityFilter: "A la entidad",
	toCountryFilter: "Al país",
	toGroupRoleFilter: "A la función de grupo",
	toEngagementFilter: "Al compromiso",
	toServiceLineFilter: "A línea de servicio",
	toRoleFilter: "A rol",

	//ContactDB - Define Attributes
	defineAttributes: "Definir atributos",

	// ContactDB Edit Entity Modal
	// Step 2 - Edit Entity Modal
	addAnotherEntityAdministrator: "Agregar otro administrador de entidad",
	editEntity: "Editar entidad",
	entityAdministrators: "Administradores de entidades (opcional)",
	editEntityAdministratorsInstruction: "Tiene la opción de agregar uno o más administradores de entidades. Pueden agregar contactos a esta entidad y brindar acceso a los módulos de EY Canvas Oversight.",
	editEntityDomainInstruction: "Los miembros externos del equipo deben tener un dominio válido para que esta entidad acceda a EY Canvas Oversight. El sistema importará dominios aprobados de compromisos de EY Canvas conectados en el Paso 4 del asistente de configuración. Si planea invitar a otros miembros externos del equipo a esta entidad, agregue uno o más dominios. Un dominio son los caracteres después del símbolo @ en una dirección de correo electrónico.",
	level: "Nivel {0}",

	// ContactDB Remove Contacts
	removeIcon: "Eliminar",
	removeContactTitle: 'Remove contacts',
	removeInstructionalText: "¿Está seguro de que desea eliminar estos contactos de su proyecto? Si estos contactos pertenecen a varias entidades, se eliminarán de todas las entidades. Si necesita eliminar un contacto de una entidad individual, seleccione en ese caso, editar su acceso.",
	removeSelectedContacts: "Contactos seleccionados",

	domainNotPermitted: "El dominio para uno o más administradores de entidad no está permitido para esta entidad.",
	listView: "Vista de lista",
	cardView: "Vista de tarjeta",

	recordsNotAvailable: "Registros no disponibles",

	// Project Layout Update
	welcomeLabel: "Bienvenidos",
	activeProjectsInstructionalText: "Usted tiene acceso a los proyectos EY Canvas Oversight listados aquí. Seleccione un módulo para navegar hasta él o haga click sobre el número para ver el detalle de cada uno de sus proyectos.",
	otherProjectsInstructionalText: "Sus compromisos de EY Canvas están conectados a los proyectos de EY Canvas Oversight listados aquí. No tienes acceso a estos proyectos. Hable con el propietario de un proyecto o el administrador de la entidad para obtener acceso.",
	completedProjectsInstructionalText: "Sus proyectos de EY Canvas Oversight listados aquí. Seleccione la opción <b>Continuar</b> para usar su proyecto completo como plantilla al crear un nuevo proyecto.",
	goToLabel: "Ir a",
	entityAdmins: "Administradores de entidades",
	entityAdmin: "Administrador de entidades",
	keyContacts: "Contactos clave",
	keyContact: "Contacto clave",
	contactListLabel: "Lista de contactos",
	draftlabel: "Borrador",
	projectWizard: "Asistente de proyectos",
	noEntityAdminsAdded: "No hay administradores de entidad asociados",
	addProjectOwner: "Agregar propietario de proyecto",
	addProjectOwnerInstrText: "Busque un usuario que use su nombre o correo electrónico para agregarlo como propietario del proyecto seleccionado.",
	projectSummary: "Resumen del proyecto",
	privacyNotice: "Aviso de privacidad",
	groupOversightProject: "Proyecto de Supervisión de Grupo (¡Nuevo!)",
	groupOversightProjectTooltip: "En <b>Group Oversight projects</b>, puede identificar su(s) compromiso(s) principal(es) y/o regional de EY Canvas para los que está creando un proyecto de EY Oversighting. Los compromisos regionales y/o de componentes de EY Canvas identificados en la estructura de su grupo de EY Canvas <b>automáticamente</b> se completarán como parte de la configuración del proyecto de EY Supervisión. <br><br> Además, este tipo de proyectos tendrán acceso a un módulo de evaluación de riesgos del Grupo donde se pueden ver las actividades de evaluación de riesgos para los compromisos primarios, regionales y/o de componentes.",
	oversightProject: "Proyecto de supervisión (auditorías estatutarias)",
	oversightProjectTooltip: "En los proyectos de supervisión (auditorías estatutarias), puede seleccionar manualmente su(s) cliente(s) y, a continuación, su(s) compromiso(s) asociado(s) de EY Canvas, para los que está creando un proyecto de EY Oversight.",

	// Group Risk Assessment
	noGroupRiskAssessmentForSelection: "No hay ninguna actividad de evaluación de riesgos del Grupo para este proyecto de supervisión de EY.",
	engagementData: "Datos del compromiso",
	engagementDetails: "Detalles del compromiso",
	reconciliations: "Reconciliaciones",
	nextComponent: "Siguiente componente",
	prevComponent: "Componente anterior",
	allAccounts: "Todas las cuentas",
	generateEmail: "Generar correo electrónico",
	reconciliationDetailInstructional: "La siguiente información resume las cuentas totales y los riesgos relacionados con el equipo componente en la estructura del grupo EY Canvas del equipo primario. Las cuentas y los riesgos deben asignarse a la cuenta y el riesgo equivalentes en el compromiso del equipo de EY Canvas del componente.",
	primaryTeamAccountName: "'Nombre de la cuenta del equipo primario",
	componentTeamAccountName: "Nombre de la cuenta del equipo del componente",
	designation: "Designación",
	openAccounts: "Cuentas abiertas",
	componentTeamAccounts: "Cuentas de equipo de componentes",
	mapAccountsMessage: "Cada cuenta de equipo primario debe tener al menos una cuenta de equipo de componentes asignados. {button} para empezar.",
	primaryTeamAccountStatus: "Estado de la cuenta del equipo primario",
	totalAccounts: "Cuentas totales",
	assessedAccounts: "Cuentas prorrateadas",
	primaryTeamRiskStatus: "Estado de riesgo del equipo primario",
	openRisks: "Riesgos abiertos",
	assessedRisks: "Riesgos evaluados",
	totalRisks: "Riesgos totales",
	primaryTeamRiskDesignationAndName: "Designación y nombre del riesgo del Equipo Primario",
	primaryTeamAccountsRelatedToRisk: "Cuenta(s) del equipo Primario relacionada con el riesgo",
	componentTeamRisksAndRelatedAccounts: "Riesgos del equipo Componente y cuenta(s) relacionada(s)",
	relateRisks: "Relacionar riesgos",
	relateRisksMessage: "Cada cuenta del equipo primario debe tener al menos un riesgo del equipo componente asignado. {button} para empezar.",
	pspIndexesHeader: "PSP",
	pspIndexes: "Índice(s) PSP",
	markAssessed: "Nota evaluada",
	markReOpen: "Volver a abrir",
	riskMarkAssessedMessage: "Revise los riesgos del equipo primario y componente que están relacionados. Una vez que haya un mapeo completo, {button}.",
	riskMarkOpenMessage: "Si es necesario realizar cambios en los riesgos que ya se han marcado como evaluados, {button} el riesgo. Esta agrupación de riesgos aparecerá en la vista Riesgos abiertos.",
	markAssessedSuccessMessage: "La cuenta relacionada se ha marcado correctamente como evaluada. Para revisar la cuenta, vaya a la vista evaluada.",
	reopenAssessedAccount: "Volver a abrir",
	reopenAssessedAccountMessage: "Si es necesario realizar cambios en las cuentas que ya se han marcado como evaluadas, {button} la cuenta. Esta agrupación de cuentas aparecerá en el bucket Abierto.",
	reopenSuccessMessage: "La cuenta relacionada se ha vuelto a abrir con éxito. Para revisar la cuenta, vaya a la vista abierta.",
	teamAccountMappedMessage: "Revise las cuentas de equipo primario y componentes que están asignadas. Una vez que haya un mapeo completo, {button}.",
	teamAccountWasPreviousAssessedMessage: 'This primary and component team account grouping was previously marked assessed but there were changes to the account(s). Review primary and component team accounts to ensure the mapping is still correct. Once complete, {button}.',
	createComment: "Crear comentario",
	editComment: "Editar comentario",
	commentTitle: "Comentario",
	createCommentInstructionalText: "Ingrese los detalles del comentario para la cuenta o riesgo seleccionado y seleccione 'Guardar' para finalizar.",
	editCommentInstructionalText: "Edite los detalles del comentario para la cuenta o el riesgo seleccionado y seleccione 'Guardar' para finalizar.",
	lastModified: "Última modificación",
	addComment: "Agregar comentario",
	accountDescription: "Seleccione Abrir cuentas para ver las cuentas del equipo primario que no se han relacionado con las cuentas del equipo de componentes y que se han marcado como evaluadas. Seleccione Cuentas evaluadas para ver las cuentas de equipo primario que se han evaluado.",
	riskDescription: "Seleccione Riesgos abiertos para ver los riesgos del equipo Primario que no se han relacionado con los riesgos del equipo Componente y se han marcado como evaluados. Seleccione Riesgos evaluados para ver los riesgos del equipo Primario quehan sido evaluados.",
	successAssessedMessage: "Los riesgos relacionados han sido evaluados con éxito. Para ver los riesgos, vaya a la vista evaluada.",
	successReOpenMessage: "Los riesgos relacionados se han reabierto con éxito. Para ver los riesgos, vaya a la vista abierta.",

	// Relate risks modal
	relateRisksModalTitle: "Relacionar los riesgos del equipo de Componentes con los riesgos del equipo Primario",
	relateRisksModalInstructionalText: "Seleccionar Riesgo(s) del equipo Componente(s) a continuación para relacionarlo con el riesgo del equipo Primario seleccionado.",
	primaryRegionTeamRisk: "Riesgo del equipo Primario:",
	primaryTeamRiskLabel: "Riesgo del equipo Primario:",
	thereIsNoDataToDisplayForThisSelection: "No hay datos para mostrar para esta selección.",
	accountAndAsssociated: "Cuenta(s) y PSP(s) asociado(s)",
	disabledRegionComponentTeamRiskLabel: "Este riesgo de equipo Componente ya está asignado a otro riesgo del equipo Primario. Un riesgo de equipo Componente solo se puede asignar a un riesgo de equipo Primario. Seleccione 'Relacionar riesgos' para el riesgo primario relevante para desvincular este riesgo, según corresponda.",
	selectOneOrMore: "Seleccione uno o más",

	relateAccountsModalTitle: "Relacionar las cuentas de equipo de componentes con las cuentas de equipo principal",
	relateAccountName: "Cuenta principal del equipo:",
	relateAccountpspIndex: "Índice PSP del equipo Primario:",
	relateAccountpspIndexes: "Índices PSP del equipo Primario:",
	relateAccountInstructionalText: "Seleccione Cuenta(s) de equipo de Componentes a continuación para relacionarse con la cuenta de equipo Primario seleccionada.",
	pspIndexcountLabel: "Índices de PSP relacionados con la cuenta de equipo Primario/regional",
	relateAccounts: "Relacionar cuentas",

	viewComponentTeamAccountsText: "Ver cuentas de equipo de Componentes",
	componentTeamAccountsModalTitle: "Cuentas de equipo Componentes no relacionadas y/o no aplicables",
	componentTeamAccountsModalInstructionalText: "Las cuentas del equipo Componente deben estar relacionadas con una cuenta de equipo Primario. Vuelva a la página subyacente para relacionar cuentas. Si la cuenta de equipo del Componente no es aplicable a la auditoría de grupo, marque la cuenta como \'No aplicable\'.",
	componentTeamAccountsModalNotApplicableInstructionalText: "Las cuentas de equipo de componentes no aplicables se marcan de esta manera porque no son aplicables a la auditoría de grupo. Si una cuenta aparece a continuación por error, mueva la cuenta de nuevo a \'No relacionada\' para relacionar esta cuenta con una cuenta de equipo principal.",
	notRelatedTab: "No relacionado",
	notApplicableTab: "No aplicable",
	unmapped: "Sin mapear",
	unrelate: "Desvincular",
	action: "Acción",
	notApplicableActionTitletip: 'Al seleccionar "Desvincular", el riesgo se moverá a la pestaña "No relacionado".Los riesgos que son "No relacionados" deben estar relacionados con un riesgo del equipo principal o marcarse como "No aplicable" si no son aplicables a la auditoría de grupo.',
	notRelatedActionTitletip: 'Al seleccionar "No aplicable", el riesgo se moverá a la pestaña "No aplicable". Los riesgos del equipo de los componentes que son "No aplicables" no son aplicables a la auditoría del grupo.',
	higherInheritRisk: "Riesgo inherente alto",
	lowerInheritRisk: "Riesgo inherente bajo",
	riskAssociated: "Riesgo asociado",
	riskAssociatedHigher: "Riesgo asociado y contribuye al mayor riesgo inherente",

	viewComponentTeamRisks: "Ver riesgos del equipo Componente",
	unmappedRisksModalTitle: "Riesgos del equipo Componentes No relacionados y/o No aplicables",
	unmappedRisksModalInstructional: 'Los riesgos del equipo Componentes deben estar relacionados con un riesgo del equipo Primario. Regrese a la página subyacente para relacionar los riesgos. Si el riesgo del equipo Componente no es aplicable a la auditoría de grupo, marque el riesgo como "No aplicable ".',
	notApplicableRisksModalInstructional: 'Los riesgos de equipo Componentes No aplicables se marcan de esta manera porque no son aplicables a la auditoría de grupo. Si un riesgo aparece a continuación por error, vuelva a mover el riesgo a "No relacionado" para relacionar este riesgo con un riesgo del equipo Primario.',
	added: "Añadido",
};

export const temporaryLabels = {
	dryDock: "Drydock",
	darkMode: "Modo oscuro",
	dashboard: "Tablero",
	projects: "Proyectos",
	scopeStrategy: "Alcance y estrategia",
	accountSummary: "Resumen de la cuenta",
	scotSummary: "Resumen de Scots",
	craSummary: "Resumen de CRA",
	itSummary: "Resumen de TI",
	SPSummary: "Resumen de la evaluación sustantiva",
	auditPlan: "Plan de auditoría",
	conclusion: "conclusión",
	findings: "Resultados",
	changesReport: "Cambios después de la fecha del informe",
	teamMember: "Independencia de los miembros del equipo",
	archiveChecklist: "Lista de verificación para archivar",
	enagagementmanagement: "Gestión del compromiso",
	integration: "Integración",
	guidedWorkflow: "Flujo de trabajo guiado",
	copyrightMessage: "Derechos de autor © <año>. Todos los derechos reservados",
};

export const createGRAProjectLabels = {
	creationInstructional: "Ingrese un nombre de proyecto y seleccione un compromiso Primario o Regional de EY Canvas de la lista a continuación para crear un EY Oversight project. <br> En función del compromiso seleccionado, los compromisos de EY Canvas identificadas en la estructura del grupo de EY Canvas se completarán automáticamente como parte de la configuración de este proyecto. Haga clic en el {link} para obtener más información sobre EY Canvas Oversight.",
	projectName: labels.projectName,
	engagements: labels.engagementsLabel,
	searchPlaceholder: "Buscar el nombre del compromiso EY Canvas, el ID o el nombre del cliente.",
	noAccessToEng: "No tiene acceso a ningún compromiso de EY Canvas.",
	noDataToDisplay: labels.noDataFound,
	save: labels.save,
	cancel: labels.cancelLabel,
	engagementsRequiredMessage: "Seleccione al menos un compromiso para guardar.",
	userGuideLinkText: "Guía del usuario"
};

export const deleteCommentModalLabels = {
	titleText: "Eliminar comentario",
	instructionalText: "¿Estás seguro de que quieres eliminar el comentario?",
	triggerText: "Eliminar",
	confirmLabel: "Confirmar",
	cancelLabel: "Cancelar",
	closeLabel: "cerrar"
}

export const gaRoleType = [{
	id: GARoleTypeId.Primary,
	label: "Primario"
},
{
	id: GARoleTypeId.Region,
	label: "Región"
},
{
	id: GARoleTypeId.Component,
	label: "Componente"
}
];

export const engagementTableLabels = {
	engagementName: "Nombre del compromiso",
	clientName: labels.clientName,
	type: labels.typeLabel,
	gaRoleType
};

export const formLabels = {
	required: labels.required,
	maxLength: labels.formLengthMessage
};

export const activityLogTypes = {
	ProjectCreated: "Fecha de creación del proyecto",
	GAComponentCreated: "Componente añadido",
	GAComponentRemoved: "Componente eliminado",
	GAComponentUnlinked: "Componente desvinculado",
	AccountAdded: "Cuenta añadida",
	AccountRemoved: "Cuenta eliminada",
	AccountDesignationChanged: "Cambio en la designación de la cuenta",
	AccountEstimateChanged: "Cambio en la estimación de la cuenta",
	AccountExecutionTypeChanged: "Cambio en el tipo de ejecución de la cuenta",
	AssertionAssociated: "Aseveración asociada",
	AssertionUnassociated: "Aseveración no asociada",
	AssertionInherentRiskChanged: "Cambio en el riesgo inherente",
	AssertionControlRiskDesignationChanged: "Cambio en la designación del riesgo de control",
	RiskCreated: "Riesgo creado",
	RiskRemoved: "Riesgo eliminado",
	RiskAssociated: "Riesgo asociado",
	RiskUnassociated: "Riesgo no asociado"
};

export const activityTableLabels = {
	sourceEngagement: "Compromiso  fuente",
	activityType: "Tipo de actividad",
	objectImpacted: "Objeto impactado",
	relatedObjectImpacted: "Objeto relacionado impactado",
	relatedSecondaryObjectImpacted: "Objeto secundario relacionado afectado",
	activityDate: "Fecha de la actividad"
};

export const regionComponentRiskTableLabels = {
	regionComponentTeamRiskName: "Nombre de riesgo del equipo Componentes",
	details: "Detalles",
};

export const riskTypes = [{
	id: '1',
	label: "Riesgo significativo",
},
{
	id: '2',
	label: "Riesgo de fraude",
},
{
	id: '3',
	label: "Riesgo inherente"
}
];

export const engagementLabels = {
	accountName: "Nombre de la cuenta/divulgación",
	accountTypeName: "Designación",
	canvasEngagementId: "ID de compromiso",
	controlRiskTypeName: "Controlar el riesgo",
	engagementDescription: "Nombre del compromiso",
	inherentRiskTypeName: "Riesgo inherente",
	assertionName: "Aseveración",
	pspIndexTitle: "Índice PSP",
	riskName: "Nombre del riesgo",
	riskTypeName: "Tipo de riesgo",
	relatedTasks: "Tareas relacionadas",
	taskStatus: "Estatus de tarea",
	controlRiskAssessment: "Evaluación de riesgos de control"
};

export const groupRiskAssessmentLabels = {
	activityFeed: labels.activityFeed,
	reconciliations: labels.reconciliations,
	lastRefreshed: labels.lastRefreshed,
	groupRiskAssessment: labels.groupRiskAssessment,
	lastRefreshedReconciliation: labels.lastRefreshedReconciliation,
	lastRefreshedActivityFeed: labels.lastRefreshedActivityFeed
};

export const reconciliationsTableLabels = {
	show: labels.show,
	noDataToDisplay: "No hay datos para mostrar para esta tabla.",
	unselectedEntities: "No hay datos de conciliación para este proyecto EY Oversight. Relacione los componentes con las cuentas en el flujo de instrucciones de grupo en el compromiso EY Canvas de su equipo Primario para que los datos de conciliación se muestren aquí.",
	columns: {
		components: "Componentes",
		open: "Abrir",
		assessed: "Evaluado",
		total: "Total"
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const relateAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: "Cuenta de equipo Componentes",
		pspIndexes: "Índices PSP",
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent,
	relateAccountTableDisabledRowToolTip: 'Esta cuenta de equipo Componente ya está asignada a otra cuenta del equipo Primario. Una cuenta de equipo Componente solo se puede asignar a una cuenta de equipo Primario. Seleccione "Relacionar cuentas" en la cuenta Primaria correspondiente para desvincular esta cuenta, según corresponda.'
};

export const notRelatedAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: relateAccountsTableLabels.columns.accountName,
		pspIndexes: "Índice(s) PSP",
		notRelated: {
			actionColumnName: labels.action,
			titleTip: 'Al marcar una cuenta como "No aplicable\" se moverá la cuenta a la pestaña \"No aplicable\". Las cuentas deben marcarse como "No aplicables" si no son aplicables a la auditoría del grupo.',
			actionLabel: labels.notApplicableTab
		},
		notApplicable: {
			actionColumnName: labels.action,
			titleTip: "Al seleccionar \'Desvincular\' se moverá la cuenta a la pestaña \'No relacionado\'. Las cuentas que son \'No relacionadas\' deben estar relacionadas con una cuenta de equipo Primario o estar marcadas como \'No aplicable\' si no son aplicables a la Auditoría de Grupo.",
			actionLabel: labels.unrelate
		}
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const unmappedRisksTableColumnLabels = {
	riskName: "Riesgo del equipo Componente",
	actions: "Acción"
};

export const AdminUserErrors = {
	userError: "Usuario no encontrado."
};

/*RBAC Errors*/
export const RbacErrors = {
	106: "No tienes los permisos requeridos para realizar esta acción."
};

export const Errors = {
	106: "No tienes los permisos requeridos para realizar esta acción.",
	107: "No tienes los permisos requeridos para realizar esta acción.",
	111: "No puede delegar el acceso a sí mismo.",
	112: "Usuario no encontrado.",
	310: "Proyecto no encontrado.",
	314: "El dominio para uno o más administradores de grupo no está permitido para este grupo.",
	316: "Debe ser propietario del proyecto o administrador del grupo para agregar miembros del equipo. Hable con el propietario de un proyecto para obtener acceso.",
	317: "Solo se pueden agregar miembros internos como dueños de proyectos. Los siguientes son usuarios externos: {0}. Actualice la página e inténtelo de nuevo. Póngase en contacto con Help Desk si el error persiste.",
	318: "El dominio para {0} no está permitido para el siguiente grupo: {1}",
	319: "Este proyecto ha sido completado por otro propietario del proyecto. Actualice la página e inténtelo de nuevo. Póngase en contacto con el departamento de soporte técnico si el error persiste.",
	321: "Debe ser propietario del proyecto para completar esta acción. Hable con el propietario de un proyecto para obtener acceso.",
	323: "Este grupo ha sido eliminado por otro miembro del equipo. Actualice la página e inténtelo de nuevo. Póngase en contacto con el departamento de soporte técnico si el error persiste.",
	324: "Debe ser propietario del proyecto para  completar este proyecto. Actualice la página e inténtelo de nuevo. Póngase en contacto con el departamento de soporte técnico si el error persiste.",
	325: "Debe ser propietario del proyecto o administrador del grupo para realizar estos cambios. Hable con el propietario de un proyecto para obtener acceso.",
	326: "Complete todos los campos obligatorios para guardar este proyecto. Actualice la página e inténtelo de nuevo. Póngase en contacto con el departamento de soporte técnico si el error persiste.",
	327: "Proyecto ya guardado.",
	328: "El miembro del equipo que está intentando agregar ya es miembro de este grupo. Actualice la página e inténtelo de nuevo.",
	330: "No se puede eliminar el último propietario del proyecto",
	331: "Otro miembro del equipo ha eliminado uno o más grupos. Actualice la página e inténtelo de nuevo. Póngase en contacto con el servicio de asistencia si el error persiste.",
	332: "Se requiere al menos un propietario de proyecto. No puede retirarse de este proyecto.",
	341: "No tiene acceso a clientes o engagement seleccionados.",
	343: "Solo puede eliminar proyectos activos y en borradores. Actualice la página e inténtelo de nuevo. Póngase en contacto con Help Desk si el error persiste.",
	344: "Debe ser propietario para poder eliminar este proyecto. Actualice la página e inténtelo de nuevo. Póngase en contacto con Help Desk si el error persiste.",
	345: "Este proyecto fue eliminado por otro miembro del equipo. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
	346: "Otro propietario del proyecto o administrador de la entidad ya ha revisado el acceso para {0}. Actualice el registro de acceso e inténtelo de nuevo.",
	347: "Debe ser propietario de un proyecto o administrador de una entidad para agregar o quitar contactos de este proyecto. Hable con el propietario del proyecto para solicitar acceso.",
	348: "Solo puede eliminar contactos de las entidades que administra. Los siguientes contactos pertenecen a entidades de las que no es administrador y que no se pueden eliminar: {0}.",
	360: "Debe ser propietario de un proyecto para que este proyecto complete esta acción.",
	361: "Debe ser propietario del proyecto o administrador de la entidad para realizar esta acción. Habla con un propietario del proyecto para solicitar acceso.",
	362: "Solo puede administrar el acceso de los contactos que pertenecen a las entidades que administra. Los siguientes contactos pertenecen a entidades de las que no eres administrador y su acceso no se puede editar: {0}.",
	364: "Está intentando editar el acceso de uno o más contactos que se han eliminado de este proyecto. Actualice la página y vuelva a intentarlo.",
	365: "Está intentando editar atributos para uno o más contactos que se han eliminado de este proyecto: {0} Actualice la página e inténtelo de nuevo.",
	366: "Solo puede editar atributos para contactos que pertenezcan a las entidades que administra. Los siguientes contactos pertenecen a entidades de las que no es administrador: {0}",
	367: "La columna personalizada que está editando ha sido eliminada por otro miembro del equipo. Actualice la página y vuelva a intentarlo.",
	368: "Otro miembro del equipo eliminó la opción de columna personalizada que está editando. Actualice la página y vuelva a intentarlo.",
	369: "Debe ser propietario de un proyecto para realizar esta acción.",
	370: "Solo puede editar atributos para contactos que pertenezcan a las entidades que administra. Los siguientes contactos pertenecen a entidades de las que no es administrador: {0}",
	372: "Debe ser propietario de un proyecto para realizar esta acción.",
	373: "No se puede eliminar el propietario de un proyecto de la página de la lista de contactos. Vaya al asistente de proyectos para realizar la acción solicitada.",
	374: "No puede eliminarse a sí mismo como propietario del proyecto de este proyecto.",
	375: "No se puede eliminar al último propietario del proyecto de un proyecto. Al menos 1 propietario del proyecto debe permanecer.",
	376: "Debe ser propietario de un proyecto para agregar o eliminar un propietario de proyecto o un administrador de entidad del proyecto. Los siguientes contactos no se pueden eliminar: {0}",
	378: 'El dominio no se puede eliminar porque está en uso por un contacto en la página de lista de contactos de este proyecto de Oversight. Vaya a la página "Lista de contactos" y elimine los contactos con este dominio, luego regrese aquí para eliminar el dominio.',
	502: "Falló la llamada de compromiso. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
	503: "No tiene acceso para los clientes seleccionados.",
	601: "Falló la llamada de los clientes. Actualice la página y vuelva a intentarlo. Póngase en contacto con la mesa de ayuda si el error persiste.",
	1605: "El usuario seleccionado ya existe.",

	1803: "Operación de etiqueta realizada con datos de proyecto no válidos. Actualice la página y vuelva a intentarlo. Si el problema persiste, comuníquese con el servicio de asistencia para obtener más ayuda.",
	1804: "Debe ser propietario de un proyecto para que este proyecto realice esta operación de etiqueta.",
	1901: "El mensaje que envía la llamada a la API falló.",
	1902: "El mensaje no puede estar vacío.",
	1903: "El tamaño permitido del mensaje es de 200 caracteres",
	1904: "El tamaño permitido del texto  de devolucion de llamada es 50 caracteres",
	1905: "La longitud permitida del uri de devolución de llamada es de 50 caracteres.",
	1906: "Debe seleccionar al menos un filtro para continuar.",
	1907: "Los destinatarios no se pueden duplicar.",
	1908: "El compromiso no puede estar vacío.",
	1909: "El tipo de mensaje no es un valor válido.",
	1910: "El destinatario no puede ser un valor vacío.",
	1911: "El mensaje del brindis no puede estar vacío.",
	1912: "El tipo de destinatario no es un valor válido.",
	1913: "No tiene el acceso adecuado para enviar una notificación. Hable con el propietario del proyecto o el administrador de la entidad para solicitar acceso.",
	1914: "Las notificaciones solo se pueden enviar a contactos internos. Revise los destinatarios de los mensajes y elimine los contactos externos para continuar.",
	2101: "El Servicio de Autoría, Aprobaciones y Notificación de Políticas de EY no está disponible en este momento. No podemos confirmar si se han completado todas las políticas relevantes. Si no ha revisado las directivas pertinentes, actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",

	// Reconciliation
	2701: "Error en la llamada Obtener todas las conciliaciones.",
	2702: "Solicitud inválida.",
	2703: "Error en la llamada Get by Id Reconciliations.",
	2704: "Error en la llamada Get by Id Risks.",
	2705: "Proyecto no encontrado en la base de datos.",
	2706: "Cuenta no encontrada en la base de datos.",
	2707: "Compromiso no encontrado en la base de datos.",
	2708: "Error al crear una llamada de comentario.",
	2709: "El comentario ya ha sido creado. Actualice la página y vuelva a intentarlo.",
	2710: "Error en la llamada a la cuenta del componente del grupo de parches.",
	2711: "La cuenta de componente de grupo no se encuentra en la base de datos.",
	2712: "El comentario de justificación no puede estar vacío.",
	2713: "El comentario de justificación no puede tener más de 4000 caracteres.",
	2714: "No se encontró el riesgo de los componentes del grupo.",
	2715: "No se encontró el componente de grupo.",
	2718: "Error en la llamada de conciliación de actualización.",
	2720: "Este elemento ha sido editado o eliminado por otro usuario. Actualice y vuelva a intentarlo.",
	2721: "El comentario ya ha sido creado. Actualice la página y vuelva a intentarlo.",
};

export const clientValidationErrors = {
	ErrorAtleastOneEngagementAssociationRequired: "Conecte al menos un compromiso al organigrama para continuar.",
	ErrorAtleastOneGroupAssociationRequired: "Conecte al menos un grupo al organigrama para continuar.",
	ErrorStep2DataNotComplete: "Escriba un nombre para cada entidad del organigrama que continúe."
};

export const engagementsViewBy = [{
	id: 0,
	label: "todo",
	value: "todo"
},
{
	id: 1,
	label: "Por país",
	value: "País",
	groupAttributeName: 'countryName'
},
{
	id: 2,
	label: "Por oficina principal",
	value: "Por región",
	groupAttributeName: 'regionName'
},
{
	id: 3,
	label: "Por tipo de compromiso",
	value: "Tipo",
	groupAttributeName: 'profileNature'
}
];

export const milestones = [{
	id: 1,
	label: "alcance",
	auditPhaseId: 1,
	value: 1
},
{
	id: 2,
	label: "estrategia",
	auditPhaseId: 1,
	value: 2
},
{
	id: 3,
	label: "recorridos",
	auditPhaseId: 2,
	value: 3
},
{
	id: 4,
	label: "Pruebas interinas de control",
	auditPhaseId: 2,
	value: 4
},
{
	id: 5,
	label: "Pruebas interinas sustantivas",
	auditPhaseId: 2,
	value: 5
},
{
	id: 6,
	label: "Recorridos (proceso de final de año)",
	auditPhaseId: 2,
	value: 6
},
{
	id: 7,
	label: "Pruebas de control a finales de año",
	auditPhaseId: 2,
	value: 7
},
{
	id: 8,
	label: "Pruebas sustantivas de fin de año",
	auditPhaseId: 2,
	value: 8
},
{
	id: 9,
	label: "conclusión",
	auditPhaseId: 3,
	value: 9
},
{
	id: 10,
	label: "N/A",
	auditPhaseId: 2,
	value: 10
},
{
	id: 11,
	label: "ejecución",
	auditPhaseId: 2,
	value: 11
},
{
	id: 12,
	label: "Alcance y estrategia de las actividades de calidad",
	auditPhaseId: 1,
	value: 12
},
{
	id: 13,
	label: "Otro alcance y estrategia",
	auditPhaseId: 1,
	value: 13
},
{
	id: 14,
	label: "CRA",
	auditPhaseId: 1,
	value: 14
},
{
	id: 15,
	label: "Evaluación de riesgos y materialidad",
	auditPhaseId: 1,
	value: 15
},
{
	id: 16,
	label: "Finalizar el alcance y la estrategia",
	auditPhaseId: 1,
	value: 16
},
{
	id: 17,
	label: "Gestión post provisional del proyecto",
	auditPhaseId: 2,
	value: 17
}
];

export const daysOptions = [{
	id: daySelection.tomorrow,
	value: daySelection.tomorrow,
	label: "mañana"
},
{
	id: daySelection.next3days,
	value: daySelection.next3days,
	label: "Próximos 3 días"
},
{
	id: daySelection.next5days,
	value: daySelection.next5days,
	label: "Próximos 5 días"
},
{
	id: daySelection.next10days,
	value: daySelection.next10days,
	label: "Próximos 10 días"
},
{
	id: daySelection.next30days,
	value: daySelection.next30days,
	label: "Próximos 30 días"
}
];

export const auditPhases = [{
	id: 1,
	label: "Alcance & estrategia"
},
{
	id: 2,
	label: "ejecución"
},
{
	id: 3,
	label: "conclusión"
}
];

export const findings = [{
	id: 1,
	label: "Errores",
	subTitle: "Inexactitudes por tipo"
},
{
	id: 2,
	label: "Deficiencias",
	subTitle: "Deficiencias por gravedad"
}
];
export const risks = [{
	id: 1,
	label: '',
	subTitle: "Por tipo"
}];

export const auditStrategies = [{
	id: 1,
	label: "Sustantivo",
	subTitle: "Procedimientos sustantivos por tipo"
},
{
	id: 2,
	label: "Contrles",
	subTitle: "Controles por estrategia de prueba"
},
{
	id: 3,
	label: "IT",
	subTitle: "Procedimientos de TI por estrategia de prueba"
}
];

export const auditInsights = [{
	id: 1,
	label: "Por rol de grupo"
},
{
	id: 2,
	label: "Todo"
}
];

export const projectStatus = {
	Active: "activo",
	Draft: "Borrador",
	Cancel: "Cancelar",
	Complete: "completado",
	Delete: "borrar"
};

export const ProjectStatusLabels = [{
	label: "Inicial",
	id: 1,
	value: 'Initial'
},
{
	label: "Borrrador",
	id: 2,
	value: 'Draft'
},
{
	label: "Activo",
	id: 3,
	value: 'Active'
},
{
	label: "Cancelado",
	id: 4,
	value: 'Cancelled'
},
{
	label: "Completado",
	id: 5,
	value: 'Completed'
},
{
	label: "Borrado",
	id: 6,
	value: 'Delete'
}
];

export const projectTeamEngagementTableGroup = [{
	id: 1,
	label: "Asignaciones de preparador"
},
{
	id: 2,
	label: "Asignaciones de revisores"
}
];

export const archiveReportQualifiedType = [{
	id: archiveReportQualifiedTypeId.notSelected,
	label: "No seleccionado"
},
{
	id: archiveReportQualifiedTypeId.unqualifiedWithEmphasisOfMatter,
	label: "Opinión no calificada - Con asuntos de énfasis."
},
{
	id: archiveReportQualifiedTypeId.unqualifiedWithoutEmphasisOfMatter,
	label: "Opinión no calificada - Sin asuntos de énfasis."
},
{
	id: archiveReportQualifiedTypeId.qualifiedWithEmphasisOfMatter,
	label: "Opinión Calificada - Con asuntos de énfasis."
},
{
	id: archiveReportQualifiedTypeId.qualifiedWithoutEmphasisOfMatter,
	label: "Opinión Calificada - Sin auntos de énfasis"
},
{
	id: archiveReportQualifiedTypeId.adverseOpinionWithEmphasisOfMatter,
	label: "Opinión adversa - Con asuntos de énfasis."
},
{
	id: archiveReportQualifiedTypeId.adverseOpinionWithoutEmphasisOfMatter,
	label: "Opinión adversa - Sin asuntos de énfasis."
},
{
	id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithEmphasisOfMatter,
	label: "Abstención de opinión - Con asuntos de énfasis."
},
{
	id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithoutEmphasisOfMatter,
	label: "Abstención de opinión - Sin asuntos de énfasis."
}
];

export const strategyTableGroup = [{
	id: 1,
	label: ''
}];

export const roleForMember = [{
	id: roles.partnerInCharge,
	label: "Socio a cargo",
	roleAbbreviation: "SOC A CRG"
},
{
	id: roles.engagementPartner,
	label: "Socios de compromiso",
	roleAbbreviation: "EP"
},
{
	id: roles.executiveDirector,
	label: "Director Ejecutivo",
	roleAbbreviation: "DIR EJECUTIVO"
},
{
	id: roles.principal,
	label: "principal",
	roleAbbreviation: "PRINCIPAL"
},
{
	id: roles.seniorManager,
	label: "Gerente Senior",
	roleAbbreviation: "GERENTE SR"
},
{
	id: roles.manager,
	label: "director",
	roleAbbreviation: "DIRECTOR"
},
{
	id: roles.senior,
	label: "Senior",
	roleAbbreviation: "SENIOR"
},
{
	id: roles.staff,
	label: "personal",
	roleAbbreviation: "PERSONAL"
},
{
	id: roles.intern,
	label: "interno",
	roleAbbreviation: "Intrn"
},
{
	id: roles.engagementQualityReviewer,
	label: "Revisor de calidad de compromiso",
	roleAbbreviation: "EQR"
},
{
	id: roles.otherPartner,
	label: "Otro socio",
	roleAbbreviation: "OTRO SC"
},
{
	id: roles.gdsStaff,
	label: "GDS - Personal",
	roleAbbreviation: "GDS-PERSONAL"
},
{
	id: roles.advisory,
	label: "Asesoramiento (ITRATASCapital Humano u Otro)",
	roleAbbreviation: "Adv"
},
{
	id: roles.tax,
	label: "impuesto",
	roleAbbreviation: "impuesto"
},
{
	id: roles.executiveSupportServices,
	label: "Servicios de apoyo ejecutivo",
	roleAbbreviation: "ESS"
},
{
	id: roles.generalCounsel,
	label: "Consejero General",
	roleAbbreviation: "GCO"
},
{
	id: roles.auditQualityReviewer,
	label: "Revisor de calidad de auditoría",
	roleAbbreviation: "AQR"
},
{
	id: roles.mlComponentTeam,
	label: "Equipo de componentes de ML",
	roleAbbreviation: "MCT"
},
{
	id: roles.clientSupervisor,
	label: "Supervisor de clientes",
	roleAbbreviation: "ClntS"
},
{
	id: roles.clientStaff,
	label: "Personal del cliente",
	roleAbbreviation: "ClntSt"
},
{
	id: roles.internalAuditSupervisor,
	label: "Supervisor de Auditoría Interna",
	roleAbbreviation: "IASup"
},
{
	id: roles.internalAuditStaff,
	label: "Personal de auditoría interna",
	roleAbbreviation: "IASt"
},
{
	id: roles.regulator,
	label: "regulador",
	roleAbbreviation: "Reglr"
},
{
	id: roles.other,
	label: "Otros (por ejemplo, revisión de diligencia debida)",
	roleAbbreviation: "Otro"
},
{
	id: roles.office,
	label: "oficina",
	roleAbbreviation: "Off"
},
{
	id: roles.area,
	label: "área",
	roleAbbreviation: "área"
},
{
	id: roles.industry,
	label: "industria",
	roleAbbreviation: "IND"
},
{
	id: roles.national,
	label: "nacional",
	roleAbbreviation: "NAT"
},
{
	id: roles.global,
	label: "global",
	roleAbbreviation: "GBL"
},
{
	id: roles.gsdSenior,
	label: "GDS - Senior",
	roleAbbreviation: "GDS-SENIOR"
},
{
	id: roles.gsdManager,
	label: "GDS - Gerente",
	roleAbbreviation: "GDS - GERENTE"
}
];

export const toggleCCPEntityOptions = [{
	id: toggleCCPEntityDetail.comingDue,
	label: labels.comingDue
},
{
	id: toggleCCPEntityDetail.overdue,
	label: labels.taskStatusOverdue
},
{
	id: toggleCCPEntityDetail.returned,
	label: labels.returned
}
];


export const reportReadinessSeries = [{
	id: readinessReportCategories.comingDueOver2Weeks,
	label: `> 2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.comingDue12Weeks,
	label: `1-2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.comingDueUnder1Week,
	label: `< 1{break}${labels.week}`
},
{
	id: readinessReportCategories.overDueUnder1Week,
	label: `< 1{break}${labels.week}`
},
{
	id: readinessReportCategories.overDue12Weeks,
	label: `1-2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.overDueOver2Weeks,
	label: `> 2{break}${labels.weeks}`
}
];

export const natureOfEngagementsLabels = {
	[natureOfEngagements.auditStatements.id]: "Auditoría de los estados financieros",
	[natureOfEngagements.integratedStatements.id]: "Auditoría integrada de los estados financieros y control interno de la información financiera",
	[natureOfEngagements.reviewStatements.id]: "Revisión de los estados financieros intermedios",
	[natureOfEngagements.nonAuditAccount.id]: "Engagement que no es de auditoría con funcionalidad de cuenta/aserción/SCOT",
	[natureOfEngagements.nonAuditWorkPlan.id]: "Engagement que no es de auditoría con solo la funcionalidad del plan de trabajo"
};

export const AdminRoles = [{
	label: "Lector de administración de aplicaciones",
	id: 1
},
{
	label: "Escritor de administración de aplicaciones",
	id: 2
},
{
	label: "Superadministrador de aplicaciones",
	id: 3
}
];

export const userType = [{
	value: 1,
	label: "Interno"
},
{
	value: 2,
	label: "Externo"
}
];

export const MessageType = [{
	value: 1,
	label: "Correo electrónico"
},
{
	value: 2,
	label: "Notificación"
}
];

export const groupRole = [{
	value: 1,
	label: "Equipo principal",
	id: 1,
	selected: false,
	disabled: false
},
{
	value: 2,
	label: "Equipo regional",
	id: 2,
	selected: false,
	disabled: false
}, {
	value: 3,
	label: "Equipo componente",
	id: 3,
	selected: false,
	disabled: false
},
{
	value: 4,
	label: "Equipo del componente que informa a auditores que no son de EY",
	id: 4,
	selected: false,
	disabled: false
},
{
	value: 5,
	label: "No aplicable",
	id: 5,
	selected: false,
	disabled: false
}
];

export const accessLogResource = [{
	id: 1,
	label: "Contactos para agregar"
},
{
	id: 2,
	label: "Contactos para eliminar"
}
]

export const addContactsTabsResource = [{
	id: 1,
	label: "Acceso"
},
{
	id: 2,
	label: "Atributos"
},
{
	id: 3,
	label: "Etiquetas"
}
]

export const tags = [{
	name: "Socio de auditoría",
	id: 'auditPartner'
},
{
	name: "Gerente de auditoría del compromiso",
	id: 'auditEngagementManager'
}, {
	name: "Gerente GDS del compromiso",
	id: 'gdsEngagementManager'
}, {
	name: "Socio de Impuestos",
	id: 'taxPartner'
}, {
	name: "Gerente de impuestos del compromiso",
	id: 'taxEngagementManager'
}, {
	name: "Socio de FAIT",
	id: 'faitPartner'
}, {
	name: "Gerente FAIT del compromiso",
	id: 'faitEngagementManager'
}, {
	name: 'Advisory partner',
	id: 'advisoryPartner'
}, {
	name: "Gerente de Consultoría del compromiso",
	id: 'advisoryEngagementManager'
}, {
	name: "Especialista",
	id: 'specialist'
}, {
	name: "Administrador de clientes",
	id: 'clientadministrator'
}
];

export const dashboardContactViews = [{
	id: dashboardTabId.milestones,
	value: dashboardViewsConstants.milestones,
	tooltipText: "Progreso de la auditoría por milestone",
	key: "Milestones",
	checked: false
},
{
	id: dashboardTabId.projectManagement,
	value: dashboardViewsConstants.projectManagement,
	tooltipText: "Estado de las notas de revisión y asignaciones, incluidos los elementos atrasados. Los usuarios externos no se pueden acceder al panel de gestión de proyectos.",
	key: "Gestión de proyectos",
	checked: false
},
{
	id: dashboardTabId.groupAudit,
	value: dashboardViewsConstants.groupAudit,
	tooltipText: "Estado del equipo primario y de los componentes, incluidos los artículos devueltos y vencidos.",
	key: "Auditoría de grupo",
	checked: false
},
{
	id: dashboardTabId.groupRiskAssessment,
	value: dashboardViewsConstants.groupRiskAssessment,
	tooltipText: "Vista de la evaluación de riesgos del grupo en los equipos primarios y componentes. Esta vista no será visible para los clientes.",
	key: "Evaluación de riesgos de grupo",
	checked: false
},
{
	id: dashboardTabId.canvasClientPortal,
	value: dashboardViewsConstants.ccp,
	tooltipText: "Estado de la solicitud, incluidos los artículos atrasados, vencidos y devueltos.",
	key: "Portal del cliente de EY Canvas",
	checked: false
},
{
	id: dashboardTabId.insights,
	value: dashboardViewsConstants.insights,
	tooltipText: "Comparación de riesgos, procedimientos sustantivos, estrategia de control y conclusiones entre los equipos primarios y componentes. Los usuarios externos no pueden acceder al cuadro de mandos de Insights.",
	key: "Ideas",
	checked: false
},
{
	id: dashboardTabId.reporting,
	value: dashboardViewsConstants.reporting,
	tooltipText: "Informe sobre la preparación, las modificaciones y el estado de finalización de las tareas por país.",
	key: "Informes",
	checked: false
}
];

export const colorOptionsLabels = {
	red: "Rojo",
	orange: "Naranja",
	teal: "Verde azulado",
	blue: "Azul",
	purple: "Morado",
	green: "Verde",
	yellow: "Amarillo",
	gray: "Gris"
};

export const exportToExcelLabels = {
	yes: "Sí",
	no: "No",
	exportData: labels.exportData,
	exportButtonTitle: "Haga clic aquí para descargar la información detallada de la solicitud del cliente para las entidades seleccionadas en el organigrama de la izquierda de este proyecto de Supervisión EY.",
	projectInfo: "Información del proyecto",
	exportDate: "Fecha de exportación",
	engagementName: labels.engagementNameLabel,
	engagementId: labels.engagementId,
	requestItemNumber: "Solicitar número de artículo",
	requestTitle: "Título de la solicitud",
	priority: "Prioridad",
	status: labels.status,
	receivedDate: "Fecha de recepción",
	dueDate: "Fecha de vencimiento",
	overdue: labels.overdueLabel,
	eyContact: "Contacto EY",
	assignedTo: "Asignado a",
	statusLabels: [{
		id: 1,
		label: "Borrador"
	},
	{
		id: 2,
		label: "Sin contacto con el cliente"
	},
	{
		id: 3,
		label: "Enviado"
	},
	{
		id: 4,
		label: "Error del sistema"
	},
	{
		id: 5,
		label: "Contacto de cliente no válido"
	},
	{
		id: 6,
		label: "Pendiente de respuesta"
	},
	{
		id: 7,
		label: "Recibido"
	},
	{
		id: 8,
		label: "Aceptado"
	},
	{
		id: 9,
		label: "Devuelto"
	},
	{
		id: 10,
		label: "Retirado"
	},
	{
		id: 11,
		label: "Envío en curso"
	},
	{
		id: 12,
		label: "Aceptar en curso"
	},
	{
		id: 13,
		label: "Retiro en curso"
	},
	{
		id: 14,
		label: "Eliminar en curso"
	},
	{
		id: 15,
		label: "Retorno en progreso"
	},
	{
		id: 16,
		label: "Respuesta en curso"
	},
	{
		id: 17,
		label: "Eliminado"
	},
	{
		id: 18,
		label: "Contacto de cliente no válido devuelto"
	},
	{
		id: 19,
		label: "Revocación en curso"
	},
	{
		id: 20,
		label: "Revocado"
	},
	{
		id: 21,
		label: "Finalización en curso"
	},
	{
		id: 22,
		label: "Revocación en curso"
	}
	],
	priorityTypeLabels: [{
		id: 1,
		label: "Bajo"
	}, {
		id: 2,
		label: "Medio"
	}, {
		id: 3,
		label: "Alto"
	}, {
		id: 4,
		label: "Crítico"
	}],

	risks: {
		exportButtonTitle: "Haga clic aquí para descargar los datos detallados de la evaluación de riesgos de las entidades seleccionadas en el organigrama en el carril izquierdo de este proyecto EY Oversight.",
		tabTitle: "Detalles de la evaluación de riesgos",
		columns: {
			engagementName: labels.engagementNameLabel,
			engagementId: labels.engagementId,
			accountName: "Nombre de la cuenta/divulgación",
			pspIndex: "Índice PSP",
			accountType: "Designación",
			assertion: "Aseveración",
			inherentRisk: "Riesgo inherente",
			controlRisk: "Controlar el riesgo",
			craValue: "Evaluación de riesgos de control",
			riskType: "Tipo de riesgo",
			riskName: "Nombre del riesgo",
			relatedTasks: "Tareas relacionadas",
			taskStatus: "Estado de la tarea"
		}
	},
	exportButtonTooltip: "Haga clic aquí para descargar datos de conciliación detallados para el equipo Primario y el equipo de componentes relacionados.",
	primaryTeamEngagementName: "Nombre del compromiso del equipo Primario",
	componentTeamEngagementName: "Nombre del compromiso del equipo Componente",
	howToUseThisExport: "Cómo usar esta exportación:",
	howToUseThisExportText: "TBD - Cómo usar este texto de exportación",
	reconciliationComponentExportTabTitle: "Cuentas",
	reconciliationComponentExport: {
		status: "Estado",
		primaryTeamAccountName: "Nombre de la cuenta del equipo Primario",
		componentTeamAccountNames: "Nombre(s) de cuenta de equipo Componente",
		pspIndexes: "Índice(s) PSP",
		designation: "Designación",
		c: "C",
		eo: "E/O",
		mv: "M/V",
		ro: "R&O",
		pd: "P&D",
		comment: "Comentario"
	},
	groupRiskStatusLabels: {
		[groupRiskStatus.open]: "Abrir",
		[groupRiskStatus.assessed]: "Evaluado",
		[groupRiskStatus.mapped]: "Asignado",
		[groupRiskStatus.unmapped]: "Sin asignar",
		[groupRiskStatus.notApplicable]: "No aplicable"
	},
	reconciliationExportTabRisks: 'Risks',
	reconciliationExport: {
		status: "Estado",
		primaryTeamRiskName: 'Primary team risk name',
		componentTeamRiskName: 'Component team risk name(s)',
		riskDesignation: 'Risk designation',
		accountsRelatedToRisk: 'Account(s) related to risk',
		c: "C",
		eo: "E/O",
		mv: "M/V",
		ro: "R&O",
		pd: "P&D",
		comment: "Comentario"
	}
};

export const accountDesignationsLabels = {
	[accountDesignations.significantAccount]: "Significativo",
	[accountDesignations.limitedRiskAccount]: "Riesgo limitado",
	[accountDesignations.insignificantAccount]: "Insignificante",
	[accountDesignations.otherAccount]: "Otro",
	[accountDesignations.significantDisclosure]: "Divulgación significativa"
}

export const riskDesignationsLabels = {
	[riskTypeIds.significant]: 'Significant Risk',
	[riskTypeIds.fraud]: 'Fraud Risk',
	[riskTypeIds.insignificant]: 'Insignificant Risk'
}
